/* eslint-disable max-len */
/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
import { AfterViewInit, ApplicationRef, Component, OnInit, ComponentFactory, ComponentFactoryResolver, EventEmitter, Injector, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewEncapsulation, ViewChild, TemplateRef, ElementRef, EmbeddedViewRef, effect } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import * as L from 'leaflet';
import * as R from 'leaflet-responsive-popup';
import * as D from 'leaflet-draw';
import { of, Subject, Subscription } from 'rxjs';
import { ColorProfileOptions, MapFilter, MapFilterOption, MapModule, MapPanData } from '../../map.interface';
import { MapsService } from '../../maps.service';
import { EmployeePopupComponent } from '../map-components/employee-popup/employee-popup.component';
import { JobPopupComponent } from '../map-components/job-popup/job-popup.component';
import { OrganizationPopupComponent } from '../map-components/organization-popup/organization-popup.component';
import 'leaflet.markercluster';
import { NgxTippyProps, NgxTippyService } from 'ngx-tippy-wrapper';
import { environment as env } from '../../../../../environments/environment';
import { OriginDestinationPopupComponent } from '../map-components/origin-destination-popup/origin-destination-popup.component';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { DispatchBoardService } from '../../../../../../projects/dispatch-board/src/app/components/dispatch-board/dispatch-board.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import _ from 'lodash';
import tippy from 'tippy.js';
import { ZuperDrawerService } from '@zuper/components/zuper-drawer';
import { RouteFormOptions } from 'app/components/route-form/route-form.types';
import { DrawPopupComponent } from '../map-components/draw-popup/draw-popup.component';
import moment from 'moment';
import { JobFormComponent } from 'app/modules/jobs/job-form/job-form.component';
import { dataObj } from 'app/modules/jobs/job-form/job-form.type';
import { ZuperDialogService } from '@zuper/components/zuper-dialog';
import { TemplateService } from '../../../../../../projects/dispatch-board/src/app/core/services/template.service';
import { MatDialog } from '@angular/material/dialog';
import { catchError, debounceTime, distinctUntilChanged, map, takeUntil} from 'rxjs/operators';
import dayjs from 'dayjs';
import { NgSelectComponent } from '@ng-select/ng-select';
import { trigger, transition, style, animate, state } from '@angular/animations';
const H = window['H'];

@Component({
  selector: 'app-map-main',
  templateUrl: './map-main.component.html',
  styleUrls: ['./map-main.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('easeInOutAnimation', [
      state('void', style({
        width: '0px',
        minWidth: '0px',
        opacity: 0,
        marginRight: '0px',
        padding: '0px',
        border: '0px'
      })),
      state('*', style({
        width: '*',
        minWidth: '*',
        opacity: 1,
        margin: '*',
        padding: '*',
        border: '*',
        marginRight: '0px',
      })),
      transition('void => *', [
        animate('200ms cubic-bezier(0.25, 0.8, 0.25, 1)')
      ]),
      transition('* => void', [
        animate('200ms cubic-bezier(0.25, 0.8, 0.25, 1)')
      ])
    ])
  ]
})
export class MapMainComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  // ViewChild
  @ViewChild('filterMenuContent', { static: false }) filterMenuContentRef!: TemplateRef<any>;
  @ViewChild('routeAddJobConfirmationDialogContent', { static: true }) routeAddJobConfirmationDialogContent: TemplateRef<any>;
  @ViewChild('mapSearchInput', { static: false }) mapSearchInput!: ElementRef;
  @ViewChild('mapContainer', { static: false }) mapContainer?: ElementRef;
  @ViewChild('select', { static: false }) ngSelect: NgSelectComponent;

  // Input
  @Input() mapView: any;
  @Input() isDispatch?: boolean;
  @Input() colorProfileOptions: ColorProfileOptions;
  @Input() enableDrawToCreateRoute?: boolean = false;
  @Input() timezone?: string = moment.tz.guess();
  @Input() module?: string;

  // Output
  @Output() eventChange: EventEmitter<any> = new EventEmitter();
  @Output() jobSelected: EventEmitter<any> = new EventEmitter();
  @Output() routeCreated: EventEmitter<any> = new EventEmitter();
  @Output() drawCompleted: EventEmitter<any> = new EventEmitter();
  @Output() trackEvent: EventEmitter<any> = new EventEmitter();

  searchAll: string = '';
  openDrawer: boolean = false;
  drawerModule: string = 'USER';
  moduleUid: string;
  employeeLocation: any;
  jobLocation: any;
  previewOptions: any = {
    position: 'right',
    type: 'summary',
    mode: 'side',
    hasBackDrop: true
  };
  public tippyProps: NgxTippyProps = {
    allowHTML: true,
    theme: 'light',
    trigger: 'click',
    arrow: false,
    interactive: true,
    placement: 'bottom',
    popperOptions: {
      modifiers: [
        {
          name: 'preventOverflow',
          options: {
            padding: 12,
          },
        },
      ],
    },
    onShow: () => {
      this._dispatchBoardService.trackEvent('map_layer');
    }
  };
  pinOptions: any[] = [
    {
      key: 'jobs',
      displayName: 'text.jobs',
      showModule: this.utilityService.hasModuleAccess('JOB'),
      icon: 'ti-briefcase'
    },
    {
      key: 'routes',
      displayName: 'text.routes',
      showModule: this.utilityService.hasModuleAccess('MAPS'),
      icon: 'ti-route-vector'
    },
    {
      key: 'users',
      displayName: 'text.users',
      showModule: this.utilityService.hasModuleAccess('USER'),
      icon: 'ti-user'
    },
    {
      key: 'organizations',
      displayName: 'text.organizations',
      // showModule: this.utilityService.hasModuleAccess('ORGANIZATION')
      showModule: false,
      icon: 'ti-buildings'
    },
    {
      key: 'customers',
      displayName: 'customers.text',
      showModule: this.utilityService.hasModuleAccess('CUSTOMER'),
      icon: 'ti-users'
    },
    {
      key: 'properties',
      displayName: 'text.properties',
      showModule: this.utilityService.hasModuleAccess('PROPERTY'),
      icon: 'ti-building'
    },
    {
      key: 'assets',
      displayName: 'asset.text',
      showModule: this.utilityService.hasModuleAccess('ASSETS'),
      icon: 'ti-cube'
    },
    {
      key: 'service_territories',
      displayName: 'text.service_territories',
      showModule: this.utilityService.hasModuleAccess('MAPS'),
      icon: 'ti-flag-3'
    }
  ];
  pinOptionState: any = {
    'jobs': false,
    'routes': false,
    'users': false,
    'organizations': false,
    'properties': false,
    'customers': false,
    'service_territories': false,
    'assets': false
  };
  actualPinState: any;
  markerCluster: any = L.markerClusterGroup({
    animate: false,
    animateAddingMarkers: false,
    chunkedLoading: true,
    chunkDelay: 50
  });
  platform: any;
  currentRoute: any;
  openRouteDetails: boolean = false;
  allRoutes: any[] = [];
  currentTitleType: string = 'DEFAULT';
  openJob: boolean = false;
  jobObject: any = {};
  jobData: any = {};
  masterRouteCopy: any = {};
  allSelectedMarkers: any[] = [];
  openNewRoute: boolean = false;
  isJobSelectedForRouteAssignment: boolean = false;
  currentPolyline = { popup: null, routeDetails: null };
  customJobSelection = { enable: false, selectedJobMarkers: [], selectedJobUids: [], selectedJobAndMarker: {} };
  drawOnMapNavbarData = { toggleNavBar: false, selectedJobs: [], selectedJobUids: [], selectedRoute: null, selectedPolylinePopupInstance: null, routeHomeMarkerInstance: null };
  routeJobConfirmationDialogData = { dialogInstance: null, jobs: {}, selectedJobCount: 0, geoCords: {}, selectedRoute: null};
  jobMarkersMap = new Map<string, any>();
  routeMarkerLocations: Map<string, number> = new Map();
  employeeMarkerLocations: Map<string, number> = new Map();
  routeHomeMarkersMap = new Map<string, any>();
  assetMarkersMap = new Map<string, any>();
  employeeMarkersMap = new Map<string, any>();
  propertyMarkersMap = new Map<string, any>();
  customerMarkersMap = new Map<string, any>();
  organizationMarkersMap = new Map<string, any>();
  mapSearchToggleState: boolean = false;
  mapSettings: any = {
    'overlay_routes': false,
    'overlay_territories': false
  };
  routeFormOption: RouteFormOptions = {
    state: 'new',
    header: 'route.create'
  };

  //Filters
  showLeftScrollButton = false;
  showRightScrollButton = false;
  selectedFilterModule: MapModule = 'JOB';
  filterOptions: MapFilter;
  filterCountData: { count: Record<MapModule, number>, showClearAll: boolean } = { count: null, showClearAll: false };
  dateOptions: any;
  filterContentViewRef: EmbeddedViewRef<any> | null = null;
  filterTippyProps: NgxTippyProps = {
    allowHTML: true,
    theme: 'light',
    trigger: 'click',
    interactive: true,
    appendTo: () => document.body,
    popperOptions: {
      modifiers: [{
        name: 'preventOverflow',
        options: {
          boundary: 'viewport'
        }
      }]
    },
    placement: 'bottom',
    hideOnClick: true,
    arrow: false,
    onShow: (instance: any) => {
      this.filterInstanceData.instanceRef = instance;
    },
    onHidden: (instance) => {
      instance.destroy();
      this.filterInstanceData.instanceRef = null;
      if (this.filterContentViewRef) {
        this.filterContentViewRef.destroy();
        this.filterContentViewRef = null;
      }
    }
  };
  filterInstanceData: { filter: any; isOpened: boolean; instanceRef: any } = { filter: {}, isOpened: false, instanceRef: null };
  selectedOptionsBucket: any = {};
  filterValueMap: any;
  tooltipData = { markerInstance: null, module: null };
  nearbyConfig: { enable: boolean; range: { min: number; max: number; value: number; rangeList: number[]; unit: string } } = { enable: false, range: { min: 6, max: 12, value: 6, rangeList: [], unit: '' } };
  nearbyZone = { circlePolylineRef: null, circleCenterGeoCords: null, oldSourceMarkerRef: null, newSourceMarkerRef: null, fromModule: null, toModule: null, eventDetails: null, circleBound: null, polylineRef: null, currentPolylineCacheId: null, teamUid: null, currentDestinationMarker: null, currentActiveMarker: null };
  nearByDistanceCache: Map<string, any> = new Map<string, any>();
  deferredCallbackFlags = { initialNearByRequestPending: false, dependenciesInitialized: false };
  jobUserAssignmentCache: Map<string, any> = new Map<string, any>();
  employeeMarkerClusters = new Map<string, { baseCoords: [number, number]; count: number; }>();
  panToMaskBtnRef: any = null;
  defaultNearbyFilterValue = { 'JOB_consider-skills': true, 'JOB_job-scheduled-date': 'TODAY', 'USER_consider-skills': true } //Key should be moduleName _ filterOptionId

  private sidebarState: Subscription;
  private markerState: Subscription;
  private map: any;
  private tileLayer: any;
  // eslint-disable-next-line max-len
  private satelliteUrl: string = null;
  private mapTileUrl: string = window['mapTileUrl'];
  private activeGeoCords: number[];
  private currentLocation: number[];

  private drawerPreviewUid: Subscription;

  private employeeGroupsMarker: any[] = [];
  private employeeLayerGroup: any = L.layerGroup();;
  private employeeLocationData: Subscription;

  private assetGroupsMarker: any[] = [];
  private assetLayerGroup: any = L.layerGroup();;
  private assetLocationData: Subscription;

  private propertyLocationData: Subscription;
  private propertyGroupsMarkers: any[] = [];
  private propertyLayerGroup: any = L.layerGroup();;

  private jobLocationData: Subscription;
  private jobGroupsMarker: any[] = [];
  private jobLayerGroup: any = L.layerGroup();
  private jobDrawer: Subscription;

  private organizationLocationData: Subscription;
  private organizationGroupsMarker: any[] = [];
  private organizationLayerGroup: any = L.layerGroup();;

  private customerLocationData: Subscription;
  private customerGroupsMarker: any[] = [];
  private customerLayerGroup: any = L.layerGroup();;

  private routeLocationData: Subscription;
  private routeLayerGroup: any = L.layerGroup();;

  private serviceTerritoryLocationData: Subscription;
  private territoryDrawer: Subscription;
  private territoryLayerGroup: any = L.layerGroup();;
  private territoryGroup: any[] = [];

  private mainGroupsMarker: any[] = [];
  private mainLayerGroup: any;
  private mapTerritoryDetails: any = {};
  public serviceTerritory: any[] = [];

  //Draw on Map
  private drawControl: any;
  private drawnLayers: any;
  routeCreationTimezone: any = moment.tz.guess();
  defaultJobMarkerIcon = L.divIcon({
    className: 'custom-div-icon',
    html: this._MapService.getDefaultJobIcon(),
    iconSize: [40, 52],
    iconAnchor: [15, 40]
  });
  defaultCustomerIcon = L.divIcon({
    className: 'custom-div-icon',
    html: this._MapService.getDefaultCustomerIcon(),
    iconSize: [40, 52],
    iconAnchor: [15, 40]
  });

  defaultAssetIcon =  L.divIcon({
    className: 'custom-div-icon',
    html: this._MapService.getDefaultAssetIcon(),
    iconSize: [40, 52],
    iconAnchor: [15, 42]
  });
  defaultPropertyIcon =  L.divIcon({
    className: 'custom-div-icon',
    html: this._MapService.getDefaultPropertyIcon(),
    iconSize: [40, 52],
    iconAnchor: [15, 40]
  });

  unSubscribe$: Subject<void> = new Subject()
  activeTool: string | null = null;
  isDrawing = false;
  toolButtons: any[] = [];
  floatingActionButton = { infoMessage: '', showInfo: false, showClearBtn: false, lastActiveTool: null };

  //Legend
  legendDetails = { jobs: {}, customers: {}, assets: {}, properties: {} };
  currentCenter: L.LatLng | null = null;
  currentBound: L.LatLngBounds | null = null;
  previousZoom: number = -1;
  dateFormat: string;
  timeFormat: string;
  dateTimeFormat: string;

  constructor(
    private _toast: HotToastService,
    private _resolve: ComponentFactoryResolver,
    private _injector: Injector,
    private _appRef: ApplicationRef,
    private _tippyService: NgxTippyService,
    private _localStorageService: LocalStorageService,
    private _dataCollectorService: DataCollectorService,
    private _dispatchBoardService: DispatchBoardService,
    private _dispatchTemplateBoardService: TemplateService,
    private _zuperDrawerService: ZuperDrawerService,
    public utilityService: UtilityService,
    public zuperDialogService: ZuperDialogService,
    private matDialog: MatDialog,
    public _MapService: MapsService,

  ) {
    this.satelliteUrl = this._MapService.satelliteUrl;
    this.dateFormat = this._dispatchBoardService.dateFormat;
    this.timeFormat = this._dispatchBoardService.timeFormat;
    this.dateTimeFormat = this._dispatchBoardService.dateTimeFormat;
    this.initiateSignalEffects();
   }

  initiateSignalEffects(): void {
    effect(() => {
      this.updateNearbyState();
    }, { allowSignalWrites: true });
  }

  updateNearbyState(): void {
    const isNearByEnabled = this._MapService.isNearByEnabled() ?? false;
    const wasEnabled = this.nearbyConfig.enable;
    this.nearbyConfig.enable = isNearByEnabled;
    this.nearByDistanceCache.clear();
    this.jobUserAssignmentCache.clear();
    if (wasEnabled && !isNearByEnabled) {
      this.cleanupAllHoverBehaviors();
    }
    if (isNearByEnabled) {
      this.initMapFilterDependency();
    } else {
      this. cleanUpMapFilterDependency();
      this.clearNearbyData();
    }

    this.updateMarkerListeners();
  }

  private compilePopup(component, onAttach): any {
    const compFactory: ComponentFactory<Component> = this._resolve.resolveComponentFactory(component);
    const compRef = compFactory.create(this._injector);
    if (onAttach) { onAttach(compRef); }

    this._appRef.attachView(compRef.hostView);
    compRef.onDestroy(() => this._appRef.detachView(compRef.hostView));

    const div = document.createElement('div');
    div.appendChild(compRef.location.nativeElement);
    return div;
  }

  setTileLayer(type: string, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.map.removeLayer(this.tileLayer);
    this.currentTitleType = type;
    if (type === 'SATELLITE') {
      this.tileLayer = L.tileLayer(this.satelliteUrl, { styleId: 997, edgeBufferTiles: 5 }).addTo(this.map);
    } else if (type === 'DEFAULT') {
      this.tileLayer = L.tileLayer(this.mapTileUrl, { styleId: 997, edgeBufferTiles: 5 }).addTo(this.map);
    }
  }

  pinOptionChange(key: string): void {
    this.pinOptionState[key] = !this.pinOptionState[key];
  }

  getPinValue(key): boolean {
    return this.pinOptionState[key];
  }

  setOptionState(): void {
    const metaData = this._localStorageService.getLocalStorage('dispatch_board_metadata');
    if(this._dispatchBoardService.activeDispatchTab === 'JOBS') {
      if (this._dispatchBoardService.enableMapLayerByDefault.jobs) {
        metaData.map.layers.jobs = true;
      }
      if (this._dispatchBoardService.enableMapLayerByDefault.serviceTerritory) {
        metaData.map.layers.service_territories = true;
      }

    }
    else if(this._dispatchBoardService.activeDispatchTab === 'ROUTES') {
      if(this._dispatchBoardService.enableMapLayerByDefault.routes) {
        metaData.map.layers.routes = true;
      }
      if(this._dispatchBoardService.enableMapLayerByDefault.routesJob) {
        metaData.map.layers.jobs = true;
      }
      if (this._dispatchBoardService.enableMapLayerByDefault.serviceTerritory) {
        metaData.map.layers.service_territories = true;
      }
    }
    if (metaData?.map?.layers) {
      this.actualPinState = metaData.map.layers;
    }
    if (!this.actualPinState) {
      this.pinOptionState = {
        'jobs': false,
        'routes': false,
        'users': false,
        'organizations': false,
        'properties': false,
        'customers': false,
        'service_territories': false,
        'assets': false
      };
    } else {
      this.pinOptionState = { ...this.actualPinState };
    }
  }

  openFilter(): void {
    this.eventChange.emit({
      'event': 'FILTER',
    });
  }

  openSettings(): void {
    this.eventChange.emit({
      'event': 'SETTINGS',
    });
  }

  savePinState(): void {
    let metaData = this._localStorageService.getLocalStorage('dispatch_board_metadata');
    this.actualPinState = { ...this.pinOptionState };
    if(this._dispatchBoardService.activeDispatchTab === 'JOBS') {
      if (!this.pinOptionState.jobs) {
        this._dispatchBoardService.enableMapLayerByDefault.jobs = false;
      }
      if (!this.pinOptionState.service_territories) {
        this._dispatchBoardService.enableMapLayerByDefault.serviceTerritory = false;
      }
    }
    if(this._dispatchBoardService.activeDispatchTab === 'ROUTES') {
      if(!this.pinOptionState.routes) {
        this._dispatchBoardService.enableMapLayerByDefault.routes = false;
      }
      if(!this.pinOptionState.jobs) {
        this._dispatchBoardService.enableMapLayerByDefault.routesJob = false;
      }
      if (!this.pinOptionState.service_territories) {
        this._dispatchBoardService.enableMapLayerByDefault.serviceTerritory = false;
      }
    }
    if (metaData) {
      metaData['map']['layers'] = this.actualPinState;
    } else {
      metaData = {
        'map': {
          'enable_map_view': true,
          'nearby_jobs': true,
          'layers': this.actualPinState
        }
      };
    }
    this._MapService.toggleMapDrawTool(this.actualPinState?.routes);
    const payload = { 'meta_data': { 'module': 'SCHEDULE', 'key': 'DISPATCH_BOARD_V3', 'value': JSON.stringify(metaData) } };
    this._dataCollectorService.postData(this._dispatchBoardService.metaDataUrl, payload)
      .subscribe({
        next: (response) => {
          this._localStorageService.setLocalStorage('dispatch_board_metadata', metaData);
          this.eventChange.emit({
            'event': 'PIN',
            'data': this.actualPinState
          });
          this._MapService.mapCurrentLocation.next({ additionalData: { metaData: this._dispatchTemplateBoardService.metaData } });
          this._tippyService.hideAll();
        },
        error: (err) => {
          if (err?.message) {

          } else if (err?.data?.message) {

          } else {

          }
        }
      });
  }

  cancelPinState(): void {
    this._tippyService.hideAll();
  }

  clearMapSearch(): void {
    this.searchAll = '';
    if (this.mainLayerGroup) {
      // this.map.removeLayer(this.organizationLayerGroup);
      this.markerCluster.removeLayer(this.mainLayerGroup);
      this.mainLayerGroup = '';
      this.mainGroupsMarker = [];
      this.markerCluster.refreshClusters();
    }
  }

  moveToTerritory(territory: any): void {
    if (territory?.territory_coordinates?.length === 2) {
      this.map.fitBounds(territory?.territory_coordinates);
    } else if (territory?.territory_coordinates?.length > 2) {
      const bounds = L.polygon(territory?.territory_coordinates).getBounds();
      this.map.fitBounds(bounds);
    } else if (territory?.territory_type === 'RADIUS' && territory?.territory_radius?.geo_cordinates?.length > 0 && territory?.territory_radius?.radius) {
      this.map.setView(territory?.territory_radius?.geo_cordinates, 15);
    }
  }

  onAutocompleteSelected(result: any): void {
    if (result?.address) {
      this.activeGeoCords = [result.address.geoLocation.latitude, result.address.geoLocation.longitude];
      if (!this.isDispatch) {
        this.map.setView([this.activeGeoCords[0], this.activeGeoCords[1]], 16);
        //Initializing Icon
        const icon = L.divIcon({
          className: 'custom-div-icon',
          html: `<img style="width:100%" src="assets/images/svgs/map_main_marker.svg" alt="main marker icon">`,
          iconSize: [40, 52],
          iconAnchor: [15, 42]
        });


        const marker = L.marker(this.activeGeoCords, {
          icon: icon
        });

        //Grouping markers
        this.mainGroupsMarker.push(marker);

        //Adding the group to map
        this.mainLayerGroup = L.layerGroup(this.mainGroupsMarker);
        this.markerCluster.addLayer(this.mainLayerGroup);
        this.map.addLayer(this.markerCluster);

      } else {
        this.map.setView([this.activeGeoCords[0], this.activeGeoCords[1]], 13);
      }
    }
  }

  toggleSearch() {
    if (!this.searchAll?.length) {
      this.mapSearchToggleState = !this.mapSearchToggleState;
  
      if (this.mapSearchToggleState) {
        requestAnimationFrame(() => {
          this.mapSearchInput?.nativeElement.focus();
        });
      }
    }
    this.checkFilterScrollButtons();
  }

  previewDataEventHandler(event: any): void {
    if (event?.action === 'UPDATE' && event?.job) {
      this._MapService.updateList.next({
        module: 'JOB'
      });
    }
    if (event.drawerClosed) {
      this.openDrawer = false;
    }
  }

  initiateMapEventListener(): void {
    this.map.on('moveend', _.debounce((event: any) => this.handleMapMovement(event), 500));
    this.map.on('zoomend', _.debounce(() => this.handleZoomChange(this.map), 500));
  }

  stopMapEventListener(): void {
    this.map.off('moveend');
    this.map.off('zoomend');
  }

  handleMapMovement(event: any): void {
    const target = event?.target as L.Map;
    if (!target) { return; }
    const newCenter = target.getCenter();
    const zoom = target.getZoom() || 0;
    const distanceFromLastCenter = this.currentCenter ? newCenter.distanceTo(this.currentCenter) : 0;
    if (distanceFromLastCenter >= this._MapService.getDynamicRadius(this.previousZoom) || zoom !== this.previousZoom) {
      this.currentCenter = newCenter;
      this.currentBound = target.getBounds();
      const data: MapPanData = {
        geo_cords: [newCenter.wrap().lat, newCenter.wrap().lng],
        data: event,
        distance: distanceFromLastCenter,
        zoom: zoom,
        isWithinBound: false,
        radius: this._MapService.getDynamicRadius(zoom),
      };
      if (this.isDispatch) {
        data.additionalData = { metaData: this._dispatchTemplateBoardService.metaData };
      }
      this._MapService.mapCurrentLocation.next(data);
      this.previousZoom = zoom;
    }
  }

  handleZoomChange(mapInstance: any): void {
    const zoom = mapInstance.getZoom();
    const newCenter = mapInstance.getCenter();
    const distanceFromLastCenter = this.currentCenter ? newCenter.distanceTo(this.currentCenter) : 0;
    const dynamicRadius = this._MapService.getDynamicRadius(zoom);

    if (distanceFromLastCenter >= dynamicRadius * 0.5 || zoom !== this.previousZoom) {
      this.currentCenter = newCenter;
      const data: MapPanData = {
        geo_cords: [newCenter.wrap().lat, newCenter.wrap().lng],
        data: newCenter,
        distance: distanceFromLastCenter,
        zoom: zoom,
        isWithinBound: false,
        radius: dynamicRadius
      };
      this._MapService.mapCurrentLocation.next(data);
      this.previousZoom = zoom;
    }
  }

  private initMap(is_coords: boolean): void {
    let center; let zoom;
    if (is_coords) {
      center = this.activeGeoCords;
      zoom = 11;
    } else {
      center = [40.6000135, -25.2314079];
      zoom = 3;
    }

    this.map = L.map('map', {
      center: center,
      zoom: zoom,
      zoomControl: false,
      attributionControl: false,
      tms: true,
      worldCopyJump: true,
      minZoom: 3,
      preferCanvas: true
    });

    this.map.whenReady(()=>{
      this.eventChange.emit({
        event: 'MAP-LOADED'
      });
      this.drawOnMapNavbarData.toggleNavBar = false;
      this._MapService.initalMapCurrentLocation = is_coords ? this.activeGeoCords : [40.6000135, -25.2314079];
      this.addMapLegendButtonInToolbar();
      this.addCustomJobSelectButtonInToolbar();
      this.setDrawOnMapConfig();
      this.initializeDrawToolButtons();
    });
    if (this.isDispatch) {
      if (this._dispatchBoardService.activeDispatchTab === 'ROUTES') {
        this.initiateMapEventListener();
      }
    }
    L.control.zoom({ position: 'bottomright' }).addTo(this.map);
    this.tileLayer = L.tileLayer(this.mapTileUrl, { styleId: 997, edgeBufferTiles: 5 }).addTo(this.map);
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    setTimeout(function(this) {
      window.dispatchEvent(new Event('resize'));
    }, 500);

    this._MapService.mapResizeIndicator
    .pipe(takeUntil(this.unSubscribe$))
    .subscribe((result: any) => {
      if(result) {
        this.map?.invalidateSize();
        if (this._MapService.isNearByEnabled()) {
          this.checkFilterScrollButtons();
        }
      }
    });

    this._MapService.requestNearByData
    .pipe(takeUntil(this.unSubscribe$))
    .subscribe((nearbyRequest: { fromModule: MapModule, toModule: MapModule, eventDetails: any, teamUid: string}) => {
      if (!nearbyRequest?.fromModule || !nearbyRequest?.toModule || !nearbyRequest?.eventDetails) {
        return;
      }
      this.selectedFilterModule = nearbyRequest?.toModule;
      this._MapService.openTooltip.jobUid = null;
      this._MapService.openTooltip.routeUid = null;
      this.deferredCallbackFlags = { initialNearByRequestPending: false, dependenciesInitialized: false };
      if (!this._MapService.isNearByEnabled()) {
        this._MapService.isNearByEnabled.set(true);
      }
      else {
        this.deferredCallbackFlags.dependenciesInitialized = true;
      }

      let eventUid: string; 
      let markerRef: any;
      let geoCords: number[] = null;
      this.nearbyZone.fromModule = nearbyRequest.fromModule;
      this.nearbyZone.teamUid = nearbyRequest.teamUid;
      this.nearbyZone.toModule = nearbyRequest.toModule;
      this.nearbyZone.eventDetails = nearbyRequest.eventDetails;
      if (nearbyRequest.fromModule === 'JOB') {
        eventUid = nearbyRequest.eventDetails?.job_uid;
        markerRef = this.jobMarkersMap.get(eventUid);
        geoCords = nearbyRequest.eventDetails?.customer_address?.geo_cordinates;
      }
      this.nearbyZone.circleCenterGeoCords = geoCords;
      if (this.nearbyZone.newSourceMarkerRef) {
        if (this.nearbyZone.fromModule === 'JOB') {
          this.jobMarkersMap.delete(this.nearbyZone.newSourceMarkerRef?.options?.eventDetails?.job_uid);
        }
        this.map.removeLayer(this.nearbyZone.newSourceMarkerRef);
      }
      this.nearbyZone.newSourceMarkerRef = null;
      if (markerRef) {
        this.nearbyZone.oldSourceMarkerRef = markerRef;
        this.markerCluster.removeLayer(markerRef);
        this.map.removeLayer(markerRef);
      }
      if (this.utilityService.isValidGeoCords(geoCords)) {
        this.createNearbyMask(geoCords);
        if (this.deferredCallbackFlags.dependenciesInitialized) {
          this.applyAndEmitNearByFilter();
        }
        else {
          this.deferredCallbackFlags.initialNearByRequestPending = true;
        }
      }
    });

    this._MapService.mapFitBoundByGeoCords
    .pipe(takeUntil(this.unSubscribe$))
    .subscribe((coordinates: any) => {
      if(coordinates) {
        const bounds = L.latLngBounds(coordinates);
        if (bounds && this.map) {
          this.map.fitBounds(bounds);
        }
      }
    });
    this._MapService.showOnMap
    .pipe(takeUntil(this.unSubscribe$))
    .subscribe({
      next: (event: any) => {
        try {
          if (event?.module && !_.isNil(event?.eventUid)) {
            if (event?.module === 'JOBS') {
              if (this.jobMarkersMap.size === 0) {
                this._MapService.openTooltip.jobUid = event?.eventUid;
                return;
              }
              this._MapService.openTooltip.routeUid = null;
              const marker = this.jobMarkersMap.get(event?.eventUid);
              this._MapService.openTooltip.jobUid = marker?.options?.job?.job_uid;
              if (marker) {
                this.setJobDetailsTooltipContent({ target: marker }, marker?.options?.job, { showFindLiveTechBtn: this._dispatchBoardService.shouldDisplayLiveTechButtonInMap });
                this.openSpecificJobMarkerPopup(marker);
              }
              else {
                this._MapService.openTooltip.jobUid = null;
              }
            }
            else if (event?.module === 'ROUTES') {
              if (this.routeHomeMarkersMap.size === 0) {
                this._MapService.openTooltip.routeUid = event?.eventUid;
                return;
              }
              this._MapService.openTooltip.jobUid = null;
              const marker = this.routeHomeMarkersMap.get(event?.eventUid);
              this._MapService.openTooltip.routeUid = marker?.options?.route?.route_uid;
              if (marker) {
                this.map.setView(marker.getLatLng(), 16);
                marker.fire('click');
              }
              else {
                this._MapService.openTooltip.routeUid = null;
              }
            }
          }
        } catch (error) { }
      },
      error: (err: any) => { }
    });
    this._MapService.clearDrawLayer
    .pipe(takeUntil(this.unSubscribe$))
    .subscribe((isDeleted: boolean) => {
      if(isDeleted) {
        this.drawnLayers?.clearLayers();
        this.disableActiveTool();
      }
    });
    this.getMarkerState();
    this.getEmployeeLocationData();
    this.getAssetLocationData();
    this.getPropertyLocationData();
    this.getJobLocationData();
    this.getOrganizationLocationData();
    this.getCustomerLocationData();
    this.getPreview();
    this.getSidebarState();
    this.getRouteLocationData();
    this.getServiceTerritoryLocationData();
    this.toggleTerritoryDrawer();
    this.toggleNewJobDrawer();

  }

  setDrawOnMapConfig(): void {
    if (this.enableDrawToCreateRoute) {
      L.extend(D);
      this.drawnLayers = new L.FeatureGroup();
      this.map.addLayer(this.drawnLayers);
      const drawPluginOptions = {
        position: 'topright',
        draw: {
          polyline: false,
          polygon: {
            allowIntersection: false,
            shapeOptions: {
              color: '#6d9ddf'
            }
          },
          circle: {
            shapeOptions: {
              clickable: false
            }
          },
          rectangle: {
            showArea: false,
            shapeOptions: {
              clickable: false
            }
          },
          marker: false,
          circlemarker: false
        },
        edit: {
          featureGroup: this.drawnLayers,
          edit: false,
          remove: false
        }
      };
      this.drawControl = new L.Control.Draw(drawPluginOptions);
      this.drawControl.addTo(this.map);
      this.map.off('draw:created');
      this.map.on('draw:created', (event: any) => {
        const layer = event.layer;
        this.allSelectedMarkers = [];
        const mapLayers = Object.values(this.map._layers);
        let clusterChildMarkers = [];
        this.map.eachLayer((layer: any) => {
          const cluster = this.markerCluster.getVisibleParent(layer);
          if (cluster?.getAllChildMarkers) {
            const markersInCluster = cluster.getAllChildMarkers();
            clusterChildMarkers = [...clusterChildMarkers, ...markersInCluster];
          }
        });
        const mapLayersAndChildMarkers = [...mapLayers, ...clusterChildMarkers];
        mapLayersAndChildMarkers.forEach((marker) => {
          if (marker?.options?.job && !marker?.options?.isRouteJob) {
            const latLng = marker.getLatLng();
            if (layer instanceof L.Rectangle) {
              if (layer.getBounds().contains(latLng)) {
                this.allSelectedMarkers.push(marker);
              }
            } else if (layer instanceof L.Polygon) {
              if (this.isMarkerInsidePolygon(latLng, layer)) {
                this.allSelectedMarkers.push(marker);
              }
            } else if (layer instanceof L.Circle) {
              if (this.isMarkerInsideCircle(marker, layer)) {
                this.allSelectedMarkers.push(marker);
              }
            }
          }
        });
        this.allSelectedMarkers = _.unionBy(this.allSelectedMarkers, 'options.job.job_uid');
        //Construct marker
        if(this.isDispatch) {
          this.drawOnMapNavbarData.toggleNavBar = true;
          this.drawOnMapNavbarData.selectedJobs = this.allSelectedMarkers.map((marker: any) => ({ 'job': marker.options.job, 'geo_cords': marker?.getLatLng()}));
          this.drawOnMapNavbarData.selectedJobUids =   this.drawOnMapNavbarData.selectedJobs.map((jobDetails: any) => jobDetails?.job?.job_uid);
          this.isJobSelectedForRouteAssignment = !!this.drawOnMapNavbarData.selectedJobs?.length;
          this.showClearSelectionFloatingBtn();
        }
        else {
          const markerPopup: any = this.compilePopup(DrawPopupComponent, (c) => {
            c.instance.jobs = this.allSelectedMarkers.length;
            c.instance.createRoute.subscribe((res: any) => {
              if (res) {
                event?.layer?.closePopup();
                this.toggleNewRoute();
              }
            });
          });

          const popup = R.responsivePopup({ minWidth: 50, offset: [5, -35], maxWidth: 150 }).setContent(markerPopup);

          event.layer.bindPopup(popup).on('popupclose', () => {
            this.drawnLayers?.clearLayers();
          });
        }
        this.drawnLayers?.clearLayers();
        this.drawnLayers.addLayer(event.layer);

        setTimeout(() => {
          event.layer.openPopup();
        }, 10);
      });
      this.map.on('draw:deletestart', (event: any) => {
        this.drawnLayers?.clearLayers();
        this.clearDrawOnMap();
        this.drawCompleted.emit({
          type: 'delete',
          selectedJob: []
        });
      });
      this.map.on('draw:drawstart', (event: any) => {
        if (this.customJobSelection.enable) {
          this.customJobSelection.selectedJobMarkers.forEach((markers: any) => {
            markers.target.setIcon(this.getJobMarkerIcon(markers?.target?.options?.job));
            markers.target.unbindTooltip();
          });
          this.customJobSelection.enable = false;
          this.isJobSelectedForRouteAssignment = false;
          this.drawOnMapNavbarData.selectedJobs = [];
          this.drawOnMapNavbarData.selectedJobUids = [];
        }
      });
    }
  }

  initializeDrawToolButtons(): void {
    if (this.enableDrawToCreateRoute) {
      this.toolButtons = [
        { tool: 'polygon', element: document.querySelector('.leaflet-draw-draw-polygon') },
        { tool: 'rectangle', element: document.querySelector('.leaflet-draw-draw-rectangle') },
        { tool: 'circle', element: document.querySelector('.leaflet-draw-draw-circle') },
        { tool: 'custom', element: document.querySelector('.leaflet-control-select-job-button') }
      ];

      this.toolButtons.forEach((button: any) => {
        if (button.element) {
          button.element.addEventListener('click', () => this.toggleDrawTool(button.tool));
        }
      });
    }
  }

  toggleDrawTool(tool: string): void {
    if (this.activeTool === tool && this.isDrawing) {
      this.disableActiveTool();
      this.map.fire('draw:deletestart');
      this.activeTool = null;
      return;
    }

    if (this.isDrawing) {
      this.disableActiveTool();
      this.map.fire('draw:deletestart');
    }

    this.activeTool = tool;
    this.activateDrawingTool(tool);
    this.isDrawing = true;
  }

  activateDrawingTool(tool: string): void {
    const selectedTool = this.toolButtons.find(button => button.tool === tool);
    if (selectedTool) {
      this.removeFloatingClearSelection();
      if (tool === 'custom') {
        this.map.fire('custom:job:select:start');
        this.floatingActionButton.infoMessage = this.utilityService.getLocaleValue('dispatchBoard.map.route.multi_select_jobs', 'Click on jobs to multi-select');
      } else {
        this.drawControl._toolbars.draw._modes[tool].handler.enable();
        this.floatingActionButton.infoMessage = this.utilityService.getLocaleValue('dispatchBoard.map.route.draw_on_map', 'Draw on map to select Jobs');
      }
      if (!selectedTool.element.classList.contains('active')) {
        selectedTool.element.classList.add('active');
      }
      this.floatingActionButton.lastActiveTool = tool;
      this.floatingActionButton.showInfo = true;
    }
  }

  disableActiveTool(): void {
    const activeButton = this.toolButtons.find(button => button.tool === this.activeTool);
    if (activeButton) {
      if (this.activeTool === 'custom') {
        this.customJobSelection.enable = false;
        this.drawCompleted.emit({
          type: 'delete',
          selectedJob: []
        });
      } else {
        this.drawControl._toolbars.draw._modes[this.activeTool].handler.disable();
      }
      activeButton.element.classList.remove('active');
    }
    this.removeFloatingClearSelection();
    this.removeFloatingInfo();
    this.isDrawing = false;
  }

  addCustomJobSelectButtonInToolbar(): void {
    if (this.enableDrawToCreateRoute) {
      const CustomControl = L.Control.extend({
        options: {
          position: 'topright',
          interactive: false
        },
        onAdd: () => {
          const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-select-job');
          const buttonElement = L.DomUtil.create('a', 'leaflet-control-select-job-button flex items-center text-center', container);
          buttonElement.title = 'Select Jobs for Route Planning';
          buttonElement.innerHTML = `<span class="sr-only">Select Jobs for Route Planning</span>`;
          L.DomEvent.disableClickPropagation(container);
          L.DomEvent.disableScrollPropagation(container);
          return container;
        }
      });
      this.map.addControl(new CustomControl());
      this.map.on('custom:job:select:start', () => {
        this.customJobSelection = { enable: true, selectedJobMarkers: [], selectedJobUids: [], selectedJobAndMarker: {} };
        this.isJobSelectedForRouteAssignment = false;
        this.drawOnMapNavbarData.selectedJobs = [];
        this.drawOnMapNavbarData.selectedJobUids = [];
        this.drawnLayers?.clearLayers();
      });
      this.map.on('custom:job:select:end', () => {
        this.customJobSelection.enable = false;
        this.clearDrawOnMap();
        this.drawCompleted.emit({
          type: 'delete',
          selectedJob: []
        });
      });
    }
  }


  addMapLegendButtonInToolbar(): void {
    if (this.colorProfileOptions?.enableLegend) {
      const CustomControl = L.Control.extend({
        options: {
          position: 'bottomright',
          interactive: false
        },
        onAdd: () => {
          this._MapService.legendButtonContainerEleRef = L.DomUtil.create('div', 'leaflet-bar leaflet-control custom-control-container legend-container border-none shadow-md cursor-pointer bg-white');
          const legendButton = L.DomUtil.create('a', 'flex items-center text-center bg-transparent legend-btn', this._MapService.legendButtonContainerEleRef);
          legendButton.title = 'Legend';
          legendButton.innerHTML = `<span class="sr-only">Legend</span>`;

          // Add click event to toggle the panel
          legendButton.onclick = (): any => {
            this._MapService.isLegendBarOpen = !this._MapService.isLegendBarOpen;
            this.toggleLegendPanel(this._MapService.legendButtonContainerEleRef, this._MapService.isLegendBarOpen);
          };
          L.DomEvent.disableClickPropagation(this._MapService.legendButtonContainerEleRef);
          L.DomEvent.disableScrollPropagation(this._MapService.legendButtonContainerEleRef);
          return this._MapService.legendButtonContainerEleRef;
        }
      });
      this.map.addControl(new CustomControl());
    }
  }

  toggleLegendPanel(legendContainer: HTMLElement, isLegendBarOpen: boolean): void {
    this._MapService.setMapLegendActiveState(legendContainer, isLegendBarOpen);
    this.eventChange.next({ event: 'LEGEND', isOpen: isLegendBarOpen, legendDetails: this.legendDetails });
  }

  removeAllCustomSelectedJobs(): void {
    this.customJobSelection.selectedJobMarkers.forEach((markers: any) => {
      markers.target.setIcon(this.getJobMarkerIcon(markers?.target?.options?.job));
      markers.target.unbindTooltip();
    });
    this.customJobSelection = { enable: false, selectedJobMarkers: [], selectedJobUids: [], selectedJobAndMarker: {} };
    this.updateCustomSelectedJobMarker();
  }

  addCustomJobSelection(jobMarker: any): any {
    const jobUid: string = jobMarker?.target?.options?.job?.job_uid;
    if (jobUid) {
      this.customJobSelection.selectedJobMarkers.push(jobMarker);
      this.customJobSelection.selectedJobUids.push(jobUid);
      this.customJobSelection.selectedJobAndMarker[jobUid] = jobMarker;
    }
  }

  removeCustomJobSelection(jobMarker: any): void {
    const jobUid: string = jobMarker?.target?.options?.job?.job_uid;
    if (jobUid) {
      this.customJobSelection.selectedJobMarkers = this.customJobSelection.selectedJobMarkers.filter((marker: any) => marker?.target?.options?.job?.job_uid !== jobUid);
      this.customJobSelection.selectedJobUids = this.customJobSelection.selectedJobUids.filter((job: any) => job !== jobUid);
      jobMarker.target.setIcon(this.getJobMarkerIcon(jobMarker?.target?.options?.job));
      delete this.customJobSelection.selectedJobAndMarker[jobUid];
    }
  }

  addOrRemoveSelectedJob(jobMarker: any): void {
    const jobUid: string = jobMarker?.target?.options?.job?.job_uid;
    if (jobUid) {
      if (this.customJobSelection.selectedJobUids.includes(jobUid)) {
        this.removeCustomJobSelection(jobMarker);
      }
      else {
        this.addCustomJobSelection(jobMarker);
      }
      this.refreshCustomSelectedJobMarker();
    }
  }

  refreshCustomSelectedJobMarker(): void {
    this.refreshDrawCompleteEvent();
    this.updateCustomSelectedJobMarker();
  }

  refreshDrawCompleteEvent(): void {
    this.drawOnMapNavbarData.selectedJobs = this.customJobSelection.selectedJobMarkers.map((marker: any) => ({ 'job': marker.target.options?.job, 'geo_cords': marker?.target?.getLatLng()}));
    this.drawOnMapNavbarData.selectedJobUids =   this.drawOnMapNavbarData.selectedJobs.map((jobDetails: any) => jobDetails?.job?.job_uid);
    this.isJobSelectedForRouteAssignment = !!this.drawOnMapNavbarData.selectedJobs?.length;
    if (this.drawOnMapNavbarData.selectedJobUids?.length) {
      this.showClearSelectionFloatingBtn();
    }
    else {
      this.removeFloatingClearSelection();
    }
  }

  clearDrawOnMap(disableTool: boolean = true, activateLastEnabledTool: boolean = false): void {
    this.drawOnMapNavbarData.toggleNavBar = false;
    this.drawOnMapNavbarData.selectedJobs = [];
    this.drawOnMapNavbarData.selectedJobUids = [];
    this.isJobSelectedForRouteAssignment = false;
    this.drawnLayers?.clearLayers();
    this.removeAllCustomSelectedJobs();
    this.removeFloatingClearSelection();
    this.removeFloatingInfo();
    if (disableTool) {
      this.disableActiveTool();
    }
    if (activateLastEnabledTool) {
      if (this.floatingActionButton.lastActiveTool) {
        this.activateDrawingTool(this.floatingActionButton.lastActiveTool);
      }
    }
    if (this.drawOnMapNavbarData.selectedPolylinePopupInstance) {
      this.drawOnMapNavbarData.selectedPolylinePopupInstance.closePopup();
      this.drawOnMapNavbarData.selectedPolylinePopupInstance.unbindPopup();
    }
    if(this.drawOnMapNavbarData.routeHomeMarkerInstance) {
      this.drawOnMapNavbarData.routeHomeMarkerInstance.target.closePopup();
      this.drawOnMapNavbarData.routeHomeMarkerInstance.target.unbindPopup();
    }
  }

  createRouteOnDraw(): void {
    this.drawCompleted.emit({
      type: 'create',
      selectedJob: this.drawOnMapNavbarData.selectedJobs
    });
    this.clearDrawOnMap();
  }

  updateCustomSelectedJobMarker(): void {
    this.customJobSelection.selectedJobMarkers.forEach((marker: any, index: number) => {
      marker.target.setIcon(this.getJobMarkerIconWithNumber(index + 1));
    });
  }

  getJobMarkerIconWithNumber(index: number): any {
    return L.divIcon({
      className: 'bg-transparent border-none',
      html: `<div class="bg-green-100 flex items-center justify-center border-green-600 border-2 w-full h-full rounded-full text-gray-700">
       <span>${index}</span>
      </div>`,
      iconSize: [36, 36],
      iconAnchor: [15, 42]
    });
  }

  getOrganizationLocationData(): void {
    this.organizationLocationData = this._MapService.organizationLocationData
      .pipe(map((res: any) => res?.filter((organizationDetails: any) => this.utilityService.isValidGeoCords(organizationDetails?.organization_address?.geo_cordinates))))
      .subscribe({
        next: (res) => {
          if (res) {
            const newOrganizationMarkersMap = new Map<string, any>();
            res.forEach(organizationDetails => newOrganizationMarkersMap.set(organizationDetails.organization_uid, organizationDetails));

            const markersToRemove = [];
            this.organizationMarkersMap.forEach((existingMarker, organizationUid) => {
              if (!newOrganizationMarkersMap.has(organizationUid)) {
                markersToRemove.push(existingMarker);
                this.organizationMarkersMap.delete(organizationUid);
              }
            });

            const markersToAdd = [];
            newOrganizationMarkersMap.forEach((organizationDetails, organizationUid) => {
              const existingMarker = this.organizationMarkersMap.get(organizationUid);
              if (existingMarker) {
                if (existingMarker?.options?.organization?.updated_at !== organizationDetails?.updated_at) {
                  markersToRemove.push(existingMarker);
                  this.organizationMarkersMap.delete(organizationUid);
                  const marker = this.createOrganizationMarker(organizationDetails);
                  if (marker) {
                    markersToAdd.push(marker);
                  }
                }
              } else {
                const marker = this.createOrganizationMarker(organizationDetails);
                if (marker) {
                  markersToAdd.push(marker);
                }
              }
            });
            if (markersToRemove?.length) {
              const layerGroupToRemove = L.layerGroup(markersToRemove);
              this.organizationLayerGroup.removeLayer(layerGroupToRemove);
              this.markerCluster.removeLayer(layerGroupToRemove);
            }

            if (markersToAdd?.length) {
              const newLayerGroup = L.layerGroup(markersToAdd);
              this.organizationLayerGroup.addLayer(newLayerGroup);
              this.markerCluster.addLayer(newLayerGroup);
            }

            if (this.map.hasLayer(this.markerCluster)) {
              this.markerCluster.refreshClusters();
            } else {
              this.map.addLayer(this.markerCluster);
            }
          }
        },
        error: (err) => {
          if (err?.data?.message) { }
        }
      });
  }

  createOrganizationMarker(organizationDetails: any): any {
    if (this.utilityService.isValidGeoCords(organizationDetails?.organization_address?.geo_cordinates)) {
      const icon = L.divIcon({
        className: 'custom-div-icon',
        html: `<img style="width:100%" src="assets/images/svgs/organization_marker.svg" alt="organization marker icon">`,
        iconSize: [40, 52],
        iconAnchor: [15, 42]
      });
      const marker = L.marker(organizationDetails?.organization_address?.geo_cordinates, {
        icon: icon,
        organization: organizationDetails
      });
      if (this.isDispatch) {
        marker.on('click', (organizationMarkerInstance: any) => {
          if (!organizationMarkerInstance.target.getPopup()) {
            this.bindMarkerPopup('organisation', organizationMarkerInstance, organizationDetails);
          }
          const popup = organizationMarkerInstance.target.getPopup();
          popup.on('remove', () => {
            organizationMarkerInstance.target.unbindPopup();
          });
        });
      } else {
        const markerPopup: any = this.compilePopup(OrganizationPopupComponent, (c) => { c.instance.data = organizationDetails; });
        const popup = R.responsivePopup({ minWidth: 280, offset: [5, -35] }).setContent(markerPopup);
        marker.bindPopup(popup);
      }

      this.organizationMarkersMap.set(organizationDetails.organization_uid, marker);
      return marker;
    };
    return null;
  }

  getMarkerPopupContent(module: 'job' | 'customer' | 'property' | 'organisation' | 'asset' | 'user' | 'territory', data: any, additionalParam?: any): any {
    switch (module) {
      case 'job': {
        return this._dispatchTemplateBoardService.getJobDetailsTemplate(data, 'DAY', { map: { enable_map_view: true } }, true, additionalParam);
      }
      case 'customer': {
        return this._MapService.getCustomerPopup(data);
      }
      case 'asset': {
        return this._MapService.getAssetPopup(data);
      }
      case 'property' : {
        return this._MapService.getPropertyPopup(data);
      }
      case 'user': {
        return this._dispatchTemplateBoardService.getUserLocationPopupTemplate(data, this.isDispatch ? this._dispatchBoardService.selectedTimezone[this._dispatchBoardService.activeDispatchTab] : null, additionalParam);
      }
      case 'territory': {
        return this._MapService.getServiceTerritoryPopup(data);
      }
    }
  }

  bindMarkerPopup(module: 'job' | 'customer' | 'property' | 'organisation' | 'asset' | 'user' | 'territory', markerInstance: any, data: any, openPopupByDefault: boolean = true, additionalTemplateParam?: any): any {
    if (module && markerInstance && data) {
      if (!markerInstance?.target) {
        markerInstance.target = markerInstance;
      }
      const markerPopup: any = this.getMarkerPopupContent(module, data, additionalTemplateParam);
      const popupContent = R.responsivePopup({ 
        minWidth: 280, 
        autoPan: true, 
        autoPanPadding: [30, 55], 
        className: additionalTemplateParam?.className,
      }).setContent(markerPopup);
      const existingPopup = markerInstance?.target?.getPopup();
      const popupOptions = {
        closeButton: true,
        minWidth: 250,
        offset: module === 'territory' ? [0, 0] : [5, -35]
      };
      if (!existingPopup) {
        markerInstance.target.bindPopup(popupContent, popupOptions);
      }
      this.tooltipData.markerInstance = markerInstance;
      this.tooltipData.module = module;
      const popup = markerInstance?.target?.getPopup();
      if (popup) {
        if (module === 'territory') {
          const popupRef = popup.setLatLng(markerInstance?.latlng)
          if (openPopupByDefault) {
            popupRef.openOn(this.map)
          }
        }
        else {
          if (openPopupByDefault) {
            markerInstance.target.openPopup();
          }
        }
        this.attachPopupEventListner(module, popup, data);
      }
      if (popup) {
        popup._popupType = this.nearbyConfig?.enable ? 'nearbyPopup' : 'standardPopup';
      }
      
      return markerInstance;
    }
    return null;
  }

  setPopupContentAndAttachEvents(module: 'job' | 'customer' | 'property' | 'organisation' | 'asset' | 'user' | 'territory', popup: any, content: string, data: any): void {
    popup.setContent(content);
    this.attachPopupEventListner(module, popup, data);
  }

  attachPopupEventListner(module: 'job' | 'customer' | 'property' | 'organisation' | 'asset' | 'user' | 'territory', popup: any, data: any): void {
    const popupElement = popup.getElement();
    if (popupElement) {
      //Close button event handler
      const closeButton = popupElement.querySelector('.leaflet-popup-close-button');
      if (closeButton) {
        const existingHandler = (closeButton as any).__closeHandler;
        if (existingHandler) {
          closeButton.removeEventListener('click', existingHandler);
        }
        const newHandler = this.handleCloseButtonClick;
        closeButton.addEventListener('click', newHandler);
        (closeButton as any).__closeHandler = newHandler;
      }
      if (module === 'job') {
        const jobTitle: HTMLElement = popupElement.querySelector('#job-title');
        const findLiveTechBtn: HTMLElement = popupElement.querySelector('#find-live-technician-btn');
        if (jobTitle) {
          jobTitle.classList.add('cursor-pointer', 'hover:underline', 'hover:text-blue-500');
          const existingHandler = (jobTitle as any).__titleHandler;
          if (existingHandler) {
            jobTitle.removeEventListener('click', existingHandler);
          }
          const newHandler = this.handleJobTitleClick.bind(this, data);
          jobTitle.addEventListener('click', newHandler);
          (jobTitle as any).__titleHandler = newHandler;
        }

        if (findLiveTechBtn) {
          const existingHandler = (findLiveTechBtn as any).__findLiveTechHandler;
          if (existingHandler) {
            findLiveTechBtn.removeEventListener('click', existingHandler);
          }
          const newHandler = this.handleFindLiveTechClick.bind(this, data);
          findLiveTechBtn.addEventListener('click', newHandler);
          (findLiveTechBtn as any).__findLiveTechHandler = newHandler;
        }
      }
      else if (module === 'customer') {
        const createJobButton: HTMLElement = popupElement.querySelector('#customer-create-job-btn');
        const customerTitle: HTMLElement = popupElement.querySelector('#customer-title');
        if (createJobButton) {
          const existingHandler = (createJobButton as any).__createJobHandler;
          if (existingHandler) {
            createJobButton.removeEventListener('click', existingHandler);
          }
          const newHandler = this.handleCustomerCreateJobClick.bind(this, data);
          createJobButton.addEventListener('click', newHandler);
          (createJobButton as any).__createJobHandler = newHandler;
        }
        if (customerTitle) {
          customerTitle.classList.add('cursor-pointer', 'hover:underline', 'hover:text-blue-500');
          const existingHandler = (customerTitle as any).__titleHandler;
          if (existingHandler) {
            customerTitle.removeEventListener('click', existingHandler);
          }
          const newHandler = this.handleCustomerTitleClick.bind(this, data);
          customerTitle.addEventListener('click', newHandler);
          (customerTitle as any).__titleHandler = newHandler;
        }
      }
      else if (module === 'asset') {
        const assetTitle: HTMLElement = popupElement.querySelector('#asset-title');
        if (assetTitle) {
          assetTitle.classList.add('cursor-pointer', 'hover:underline', 'hover:text-blue-500');
          const existingHandler = (assetTitle as any).__titleHandler;
          if (existingHandler) {
            assetTitle.removeEventListener('click', existingHandler);
          }
          const newHandler = this.handleAssetTitleClick.bind(this, data);
          assetTitle.addEventListener('click', newHandler);
          (assetTitle as any).__titleHandler = newHandler;
        }
      }
      else if (module === 'property') {
        const propertyCreateJobButton = popupElement.querySelector('#property-create-job-btn');
        const propertyTitle = popupElement.querySelector('#property-title');
        if (propertyCreateJobButton) {
          const existingHandler = (propertyCreateJobButton as any).__createJobHandler;
          if (existingHandler) {
            propertyCreateJobButton.removeEventListener('click', existingHandler);
          }
          const newHandler = this.handlePropertyCreateJobClick.bind(this, data);
          propertyCreateJobButton.addEventListener('click', newHandler);
          (propertyCreateJobButton as any).__createJobHandler = newHandler;
        }
        if (propertyTitle) {
          propertyTitle.classList.add('cursor-pointer', 'hover:underline', 'hover:text-blue-500');
          const existingHandler = (propertyTitle as any).__titleHandler;
          if (existingHandler) {
            propertyTitle.removeEventListener('click', existingHandler);
          }
          const newHandler = this.handlePropertyTitleClick.bind(this, data);
          propertyTitle.addEventListener('click', newHandler);
          (propertyTitle as any).__titleHandler = newHandler;
        }
      }
      else if (module === 'user') {
        const userTitle = popupElement.querySelector('#user-title');
        const userCreateJobButton = popupElement.querySelector('#create-job-btn');
        const userAssignToJobButton = popupElement.querySelector('#assign-job-btn');
        if (userTitle) {
          userTitle.classList.add('cursor-pointer', 'hover:underline', 'hover:text-blue-500');
          const existingHandler = (userTitle as any).__titleHandler;
          if (existingHandler) {
            userTitle.removeEventListener('click', existingHandler);
          }
          const newHandler = this.handleUserTitleClick.bind(this, data);
          userTitle.addEventListener('click', newHandler);
          (userTitle as any).__titleHandler = newHandler;
        }
        if (userCreateJobButton) {
          const existingHandler = (userCreateJobButton as any).__createJobHandler;
          if (existingHandler) {
            userCreateJobButton.removeEventListener('click', existingHandler);
          }
          const newHandler = this.handleUserCreateJobClick.bind(this, data);
          userCreateJobButton.addEventListener('click', newHandler);
          (userCreateJobButton as any).__createJobHandler = newHandler;
        }
        if (userAssignToJobButton) {
          const existingHandler = (userAssignToJobButton as any).__assignJobHandler;
          if (existingHandler) {
            userAssignToJobButton.removeEventListener('click', existingHandler);
          }
          const newHandler = this.handleUserAssignToJoBtnClick.bind(this, data);
          userAssignToJobButton.addEventListener('click', newHandler);
          (userAssignToJobButton as any).__assignJobHandler = newHandler;
        }
      }
    }
  }

  convertGeoCordsToString(geoCords: { lat: number, lng: number }): string {
    if (!geoCords?.lat || !geoCords.lng) return '';
    return `${geoCords.lat}_${geoCords.lng}`;
  }

  setAdditionalMarkerConfig(module: 'job' | 'customer' | 'property' | 'organisation' | 'asset' | 'user' | 'territory', action: string, markerInstance: any, data?: any, additionalParam?: any): void {
    if (!module || !markerInstance || !action) {
      return;
    }

    if (this.nearbyZone.polylineRef) {
      this.map.removeLayer(this.nearbyZone.polylineRef);
      this.nearbyZone.polylineRef = null;
      this.nearbyZone.currentPolylineCacheId = null;
    }

    if (this.nearbyConfig.enable && module === 'user' && this.nearbyZone.newSourceMarkerRef) {
      const sourceLatLng = this.nearbyZone.newSourceMarkerRef.getLatLng();
      const destinationLatLng = markerInstance?.originalLatLng || markerInstance?.target?.originalLatLng || markerInstance?.latlng || markerInstance?.target?.getLatLng();

      if (!sourceLatLng || !destinationLatLng) {
        return;
      }

      const latLngcacheId: string = `${this.convertGeoCordsToString(sourceLatLng)}_${this.convertGeoCordsToString(destinationLatLng)}`;
      this.nearbyZone.currentDestinationMarker = markerInstance.target || markerInstance;

      const getPopupContentConfig = (formattedDistance: string, formattedTime: string, conflicts?: any) => ({
        showCreateJob: false,
        showAssignJob: true,
        showDistance: true,
        distance: formattedDistance,
        time: formattedTime,
        jobDetails: additionalParam?.jobDetails,
        showConflict: this._dispatchBoardService.companyConfig.orgConfigJobTimeoffAlert && (this.nearbyZone.fromModule === 'JOB' && this.nearbyZone?.eventDetails?.scheduled_start_time),
        ...(conflicts !== undefined && { conflicts }),
        ...(conflicts === undefined && { conflictLoading: true })
      });

      const renderPolylineFromSections = (sections: any) => {
        try {
          const distanceMetric = this.utilityService.companyConfig?.general?.distance_metric;
          const isMiles = distanceMetric === 'MILES';

          let totalLength = 0;
          let totalDuration = 0;
          sections.forEach((section: any) => {
            if (section.length && section.duration) {
              totalLength += section.length;
              totalDuration += section.duration;
            } else if (section.spans?.length) {
              section.spans.forEach((span: any) => {
                totalLength += span.length || 0;
                totalDuration += span.duration || 0;
              });
            }
          });

          const totalDistance = isMiles ? (totalLength / 1609.344) : (totalLength / 1000);
          const formattedDistance = totalDistance
            ? `${totalDistance.toFixed(1)} ${isMiles ? this.utilityService.getLocaleValue('maps.mi') : this.utilityService.getLocaleValue('maps.km')}`
            : '-';
          const formattedTime = this.utilityService.convertSecondsToHours(totalDuration, true);
          this.nearbyConfig.range.unit = isMiles ? this.utilityService.getLocaleValue('maps.mi') : this.utilityService.getLocaleValue('maps.km');

          const targetMarker = markerInstance.target || markerInstance;
          if (targetMarker?.getPopup) {
            const popup = targetMarker.getPopup();
            if (popup) {
              const popupContent = this.getMarkerPopupContent('user', targetMarker.options.user, getPopupContentConfig(formattedDistance, formattedTime));
              popup.setContent(popupContent);

              if (this._dispatchBoardService.companyConfig.orgConfigJobTimeoffAlert) {
                const jobUserConflictCacheId = `${targetMarker.options.user.user_uid}_${this.nearbyZone.eventDetails?.job_uid}`;

                const updatePopupWithConflicts = (conflictData: any) => {
                  const conflicts = _.isNull(conflictData) ? null : {
                    jobsCount: conflictData?.jobs || 0,
                    hasTimeOff: conflictData?.timeoff || false,
                    nonJobEventsCount: conflictData?.non_job_events || 0,
                    isOutOfShift: conflictData?.user_shifts || false
                  };

                  const conflictPopupContent = this.getMarkerPopupContent('user', targetMarker.options.user, {
                    ...getPopupContentConfig(formattedDistance, formattedTime),
                    showConflict: !_.isNull(conflictData),
                    conflicts,
                    conflictLoading: false
                  });
                  this.setPopupContentAndAttachEvents('user', popup, conflictPopupContent, data);
                };

                if (this.jobUserAssignmentCache.has(jobUserConflictCacheId)) {
                  const cachedJobUserAssignmentConflicts = this.jobUserAssignmentCache.get(jobUserConflictCacheId);
                  updatePopupWithConflicts(cachedJobUserAssignmentConflicts);
                } else {
                  this._MapService.getJobUserAssignmentConflicts(this.nearbyZone.eventDetails, targetMarker.options.user).then(conflictData => {
                    this.jobUserAssignmentCache.set(jobUserConflictCacheId, conflictData);
                    updatePopupWithConflicts(conflictData);
                  });
                }
              }

              setTimeout(() => {
                if (data) {
                  data['team_uid'] = data['team_uid'] || '';
                  this.attachPopupEventListner(module, popup, data);
                }
              }, 50);
            }
          }

          let allPolylineCoordinates: [number, number][] = [];
          const polylineGroup = L.layerGroup();
          sections.forEach((section: any) => {
            if (section?.polyline) {
              const linestring = H.util.flexiblePolyline.decode(section.polyline);
              const coordinates = linestring.polyline.map(([lat, lng]) => [lat, lng]);
              allPolylineCoordinates = allPolylineCoordinates.concat(coordinates);

              const antPolyline = L.polyline(coordinates, {
                color: '#4285F4',
                weight: 7,
                opacity: 1,
                lineJoin: 'round',
                lineCap: 'round'
              });

              polylineGroup.addLayer(antPolyline);
            }
          });

          if (polylineGroup.getLayers().length > 0) {
            polylineGroup.addTo(this.map);
            if (this.nearbyZone.polylineRef) {
              this.map.removeLayer(this.nearbyZone.polylineRef);
            }
            this.nearbyZone.polylineRef = polylineGroup;
            this.nearbyZone.currentPolylineCacheId = latLngcacheId;
          }
        } catch (err) { }
      };

      if (this.nearByDistanceCache.has(latLngcacheId)) {
        const cachedSections = this.nearByDistanceCache.get(latLngcacheId);
        renderPolylineFromSections(cachedSections);
      } else {
        const routingParam = {
          routingMode: 'fast',
          transportMode: 'car',
          origin: `${sourceLatLng.lat},${sourceLatLng.lng}`,
          spans: 'duration,baseDuration,length',
          return: 'polyline',
          destination: `${destinationLatLng.lat},${destinationLatLng.lng}`
        };

        const router = this.platform.getRoutingService(null, 8);
        router.calculateRoute(routingParam, (data: any) => {
          try {
            const sections = data?.routes?.[0]?.sections || [];
            this.nearByDistanceCache.set(latLngcacheId, sections);
            const currentDestMarker = markerInstance.target || markerInstance;
            if (this.nearbyZone.currentActiveMarker === currentDestMarker) {
              renderPolylineFromSections(sections);
            }
          } catch (err) { }
        });
      }
    }
  }
  
  bindSafeHoverPopupBehaviour(marker: L.Marker, map: L.Map): void {
    const popup = marker.getPopup();
    if (!popup) {
      return;
    }
    if ((marker as any).__hoverBehavior) {
      const existing = (marker as any).__hoverBehavior;
      clearTimeout(existing.closeTimeout);
      marker.off('mouseover', existing.mouseoverHandler);
      marker.off('mouseout', existing.mouseoutHandler);
      if (existing.popupElement) {
        existing.popupElement.removeEventListener('mouseenter', existing.mouseenterHandler);
        existing.popupElement.removeEventListener('mouseleave', existing.mouseleaveHandler);
      }
    }

    let isMouseOnMarker = false;
    let isMouseOnPopup = false;
    let closeTimeout: any;
    let isDestroyed = false;

    this.nearbyZone.currentActiveMarker = marker;

    const tryClose = () => {
      clearTimeout(closeTimeout);
      closeTimeout = setTimeout(() => {
        if (isDestroyed || !this.nearbyConfig?.enable) {
          return;
        }

        if (!isMouseOnMarker && !isMouseOnPopup) {
          if (marker.isPopupOpen()) {
            marker.closePopup();
          }
          if (this.nearbyZone.polylineRef && this.nearbyZone.currentActiveMarker === marker) {
            map.removeLayer(this.nearbyZone.polylineRef);
            this.nearbyZone.polylineRef = null;
            this.nearbyZone.currentPolylineCacheId = null;
          }

          if (this.nearbyZone.currentActiveMarker === marker) {
            this.nearbyZone.currentActiveMarker = null;
          }

          delete (marker as any).__hoverBehavior;
        }
      }, 300);
    };

    const mouseoverHandler = () => {
      if (!this.nearbyConfig?.enable || isDestroyed) {
        return;
      }

      if (this.nearbyZone.currentActiveMarker && this.nearbyZone.currentActiveMarker !== marker) {
        const prevMarker = this.nearbyZone.currentActiveMarker;
        if (prevMarker.isPopupOpen()) {
          prevMarker.closePopup();
        }
        if ((prevMarker as any).__hoverBehavior) {
          (prevMarker as any).__hoverBehavior.isMouseOnMarker = false;
          (prevMarker as any).__hoverBehavior.isMouseOnPopup = false;
          (prevMarker as any).__hoverBehavior.tryClose();
        }
      }

      this.nearbyZone.currentActiveMarker = marker;
      isMouseOnMarker = true;
      clearTimeout(closeTimeout);
    };

    const mouseoutHandler = () => {
      if (isDestroyed || !this.nearbyConfig?.enable) {
        return;
      }
      isMouseOnMarker = false;
      tryClose();
    };

    marker.on('mouseover', mouseoverHandler);
    marker.on('mouseout', mouseoutHandler);

    const setupPopupHandlers = () => {
      const el = popup.getElement();
      if (!el) {
        setTimeout(setupPopupHandlers, 50);
        return;
      }

      const mouseenterHandler = () => {
        if (!isDestroyed && this.nearbyConfig?.enable) {
          isMouseOnPopup = true;
          clearTimeout(closeTimeout);
        }
      };

      const mouseleaveHandler = () => {
        if (!isDestroyed && this.nearbyConfig?.enable) {
          isMouseOnPopup = false;
          tryClose();
        }
      };

      el.addEventListener('mouseenter', mouseenterHandler);
      el.addEventListener('mouseleave', mouseleaveHandler);
      (marker as any).__hoverBehavior = {
        closeTimeout,
        mouseoverHandler,
        mouseoutHandler,
        mouseenterHandler,
        mouseleaveHandler,
        popupElement: el,
        isMouseOnMarker,
        isMouseOnPopup,
        tryClose,
        destroy: () => { isDestroyed = true; clearTimeout(closeTimeout); }
      };
    };
    setTimeout(setupPopupHandlers, 100);
  }
  
  handleCustomerCreateJobClick(data: any): void {
    this._MapService.newJobDrawerToggler.next({ module: 'CUSTOMER', data });
  }

  handlePropertyCreateJobClick(data: any): void {
    this._MapService.newJobDrawerToggler.next({ module: 'PROPERTY', data });
  }

  handleUserCreateJobClick(data: any): void {
    this._MapService.newJobDrawerToggler.next({ module: 'EMPLOYEE', data });
  }

  handleCustomerTitleClick(data: any): void {
    this._MapService.previewUid.next({ uid: data.customer_uid, module: 'CUSTOMER' });
  }

  handleAssetTitleClick(data: any): void {
    this._MapService.previewUid.next({ uid: data?.asset_uid, module: 'ASSETS' });
  }

  handlePropertyTitleClick(data: any): void {
    this._MapService.previewUid.next({ uid: data?.property_uid, module: 'PROPERTY' });
  }

  handleUserTitleClick(data: any): void {
    this._MapService.previewUid.next({ uid: data?.user_uid, module: 'USER' });
  }

  handleJobTitleClick(data: any): void {
    this._MapService.previewUid.next({ uid: data?.job_uid, module: 'JOB' });
  }

  handleFindLiveTechClick(data: any): void {
    if (data) {
      this._MapService.requestNearByData.next({
        fromModule: 'JOB', toModule: 'USER', eventDetails: data, teamUid: this._dispatchBoardService.selectedTeamUid,
      });
    }
  }

  handleRouteTitleClick(data: any): void {
    this._dispatchBoardService.previewRouteDetails.set({ show: true, routeDetailsUid: data?.route_uid, source: 'map' });
  }

  handleUserAssignToJoBtnClick(data: any): void {
    if (this.nearbyConfig.enable && this.nearbyZone.fromModule === 'JOB' && this.nearbyZone.toModule === 'USER' && data && this.nearbyZone.eventDetails?.job_uid) {
      data['team_uid'] = this.nearbyZone.teamUid;
      const assignmentConfirmationDialog = this._MapService.assignmentConfirmationDialog(this.nearbyZone.fromModule, this.nearbyZone.toModule, this.nearbyZone.eventDetails, data);
      if (assignmentConfirmationDialog) {
        assignmentConfirmationDialog.afterClosed().subscribe((result: boolean) => {
          if (result) {
            const loadingToastRef = this._toast.loading(this.utilityService.getLocaleValue('job.assgnment.updating.toast_message', 'Updating Job Assignment'));
            this._dispatchBoardService.assignJob(this.nearbyZone.eventDetails?.job_uid, data?.user_uid, data?.team_uid, (status: boolean) => {
              loadingToastRef.close();
              if (status) {
                this.emitEventChange({event: 'EVENT-UPDATE', type: 'JOB', eventDetails: this.nearbyZone.eventDetails});
                this.nearbyActionComplete();
              }
            })
          }
        })
      }
    }
  }

  nearbyActionComplete(): void {
    this._MapService.isNearByEnabled.set(false);
  }

  getCustomerLocationData(): void {
    this.customerLocationData = this._MapService.customerLocationData
      .pipe(map((res: any) => res?.filter((customerDetails: any) => this.utilityService.isValidGeoCords(customerDetails?.customer_address?.geo_cordinates))))
      .subscribe({
        next: (res) => {
          if (res) {
            this.updateLegendDetails('customers', res);
            const newCustomerMarkersMap = new Map<string, any>();
            res.forEach(customerDetails => newCustomerMarkersMap.set(customerDetails.customer_uid, customerDetails));

            const markersToRemove = [];
            this.customerMarkersMap.forEach((existingMarker, customerUid) => {
              if (!newCustomerMarkersMap.has(customerUid)) {
                markersToRemove.push(existingMarker);
                this.customerMarkersMap.delete(customerUid);
              }
            });

            const markersToAdd = [];
            newCustomerMarkersMap.forEach((customerDetails, customerUid) => {
              const existingMarker = this.customerMarkersMap.get(customerUid);
              if (existingMarker) {
                if (existingMarker?.options?.customer?.updated_at !== customerDetails?.updated_at ||
                  !_.isEqual(existingMarker?.options?.customer?.color_profile, customerDetails?.color_profile)
                ) {
                  markersToRemove.push(existingMarker);
                  this.customerMarkersMap.delete(customerUid);
                  const marker = this.createCustomerMarker(customerDetails);
                  if (marker) {
                    markersToAdd.push(marker);
                  }
                }
              } else {
                const marker = this.createCustomerMarker(customerDetails);
                if (marker) {
                  markersToAdd.push(marker);
                }
              }
            });

            if (markersToRemove?.length) {
              const layerGroupToRemove = L.layerGroup(markersToRemove);
              this.customerLayerGroup.removeLayer(layerGroupToRemove);
              this.markerCluster.removeLayer(layerGroupToRemove);
            }

            if (markersToAdd?.length) {
              const newLayerGroup = L.layerGroup(markersToAdd);
              this.customerLayerGroup.addLayer(newLayerGroup);
              this.markerCluster.addLayer(newLayerGroup);
            }

            if (this.map.hasLayer(this.markerCluster)) {
              this.markerCluster.refreshClusters();
            } else {
              this.map.addLayer(this.markerCluster);
            }
          }
        },
        error: (err) => {
          if (err?.data?.message) { }
        }
      });
  }

  createCustomerMarker(customerDetails: any): any {
    if (this.utilityService.isValidGeoCords(customerDetails?.customer_address?.geo_cordinates)) {
      const markerIcon = this.colorProfileOptions?.isEnabled && customerDetails?.color_profile
        ? this._MapService.getCustomColorProfileIcon(customerDetails) || this.defaultCustomerIcon
        : this.defaultCustomerIcon;
      const marker = L.marker(customerDetails?.customer_address?.geo_cordinates, {
        icon: markerIcon,
        customer: customerDetails
      });
      marker.on('click', (customerMarkerInstance: any) => {
        if (!customerMarkerInstance.target.getPopup()) {
          this.bindMarkerPopup('customer', customerMarkerInstance, customerDetails);
        }
        const popup = customerMarkerInstance.target.getPopup();
        popup.on('remove', () => {
          customerMarkerInstance.target.unbindPopup();
        });
      });
      this.customerMarkersMap.set(customerDetails.customer_uid, marker);
      return marker;
    }
    return null;
  }

  getJobMarkerIcon(jobDetails: any): any {
    if (this.colorProfileOptions?.isEnabled && jobDetails?.color_profile) {
      return this._MapService.getCustomColorProfileIcon(jobDetails) || this.defaultJobMarkerIcon;
    }
    return this.defaultJobMarkerIcon;
  }

  setJobDetailsTooltipContent(jobMarkerInstance: any, jobDetails: any, additionalParam?: any): void {
    const popupOffset = L.point(5, -35);
    const popupContent: string = this._dispatchTemplateBoardService.getJobDetailsTemplate(jobDetails, 'DAY', { map: { enable_map_view: true } }, true, additionalParam);
    jobMarkerInstance.target.unbindTooltip();
    const existingPopup = jobMarkerInstance.target.getPopup();
    if (!existingPopup) {
      const popup = R.responsivePopup({
      minWidth: 250,
      offset: popupOffset,
      autoPan: true,
      autoPanPadding: [30, 55]
      }).setContent(popupContent);
      jobMarkerInstance.target.bindPopup(popup, {
      closeButton: true,
      job: jobDetails
      });
    }
    jobMarkerInstance.target.openPopup();
    const popup = jobMarkerInstance.target.getPopup();
    if (popup) {
      const popupElement = popup.getElement();
      if (popupElement) {
        this.attachPopupEventListner('job', popup, jobDetails);
      }
    }
  }

  setRouteHomeTooltipContent(routeHomeMarkerInstance: any, routeDetails: any): any {
    const popupOffset = L.point(5, -35);
    const popupContent: string = this._dispatchTemplateBoardService.getRouteHomePopupContent(routeDetails, this.drawOnMapNavbarData.selectedJobs?.length || 0, this._dispatchBoardService.selectedTimezone[this._dispatchBoardService.activeDispatchTab]);
    routeHomeMarkerInstance.target.unbindTooltip();
    routeHomeMarkerInstance.target.bindPopup(
      R.responsivePopup({
      minWidth: 250,
      offset: popupOffset,
      autoPan: true,
      autoPanPadding: [30, 55]
      }).setContent(popupContent),
      {
      closeButton: true
      }
    );
    routeHomeMarkerInstance.target.openPopup();
    this.drawOnMapNavbarData.selectedRoute = routeDetails;
    this.drawOnMapNavbarData.routeHomeMarkerInstance = routeHomeMarkerInstance;
    const popup = routeHomeMarkerInstance.target.getPopup();
    setTimeout(() => {
      if (popup) {
        const popupElement = popup.getElement();
        if (popupElement) {
        const routeTitle: HTMLElement = popupElement.querySelector('#route-title');
        if (routeTitle) {
          routeTitle.classList.add('cursor-pointer', 'hover:underline', 'hover:text-blue-500');
          routeTitle.removeEventListener('click', this.handleRouteTitleClick);
          routeTitle.addEventListener('click', this.handleRouteTitleClick.bind(this, routeDetails));
        }
          const addJobToRouteButton = popupElement.querySelector('#add-job-to-route-btn');
          const closeButton = popupElement.querySelector('.leaflet-popup-close-button');
          if (addJobToRouteButton) {
            addJobToRouteButton.removeEventListener('click', this.addJobsToRouteClickEvent);
            addJobToRouteButton.addEventListener('click', this.addJobsToRouteClickEvent);
          }
          if (closeButton) {
            closeButton.removeEventListener('click', this.handleCloseButtonClick);
            closeButton.addEventListener('click', this.handleCloseButtonClick);
          }
        }
      }
    });
    return popup;
  }

  setRouteDestinationTooltipContent(routeMarkerInstance: any, routeDetails: any): any {
    const popupOffset = L.point(5, -35);
    const popupContent: string = this._dispatchTemplateBoardService.getRouteDestinationPopupContent(routeDetails, this._dispatchBoardService.selectedTimezone[this._dispatchBoardService.activeDispatchTab]);
    routeMarkerInstance.target.unbindTooltip();
    routeMarkerInstance.target.bindPopup(
      R.responsivePopup({
      minWidth: 250,
      offset: popupOffset,
      autoPan: true,
      autoPanPadding: [30, 55]
      }).setContent(popupContent),
      {
      closeButton: true
      }
    );
    routeMarkerInstance.target.openPopup();
    const popup = routeMarkerInstance.target.getPopup();
    if (popup) {
      const popupElement = popup.getElement();
      if (popupElement) {
        const closeButton = popupElement.querySelector('.leaflet-popup-close-button');
        if (closeButton) {
          closeButton.removeEventListener('click', this.handleCloseButtonClick);
          closeButton.addEventListener('click', this.handleCloseButtonClick);
        }
      }
    }
    return popup;
  }


  updateLegendDetails(module: 'assets' | 'customers' | 'jobs' | 'properties' | null, eventDetails: any[], reset: boolean = false, resetAll: boolean = false): void {
    if (resetAll) {
      if (this.legendDetails) {
        Object.keys(this.legendDetails).forEach((moduleKey: any) => {
          this.legendDetails[moduleKey] = {};
        });
      }
      return;
    }
    if (reset) {
      this.legendDetails[module] = {};
      return;
    }
    if (module && eventDetails) {
      const colorProfiles = {};
      eventDetails?.forEach((eventDetail: any) => {
        const colorProfileUid: string = eventDetail?.color_profile?.color_profile_uid;
        if (colorProfileUid) {
          colorProfiles[colorProfileUid] = eventDetail?.color_profile;
        }
      });
      this.legendDetails[module] = colorProfiles;
    }
    this.emitEventChange({ event: 'LEGEND', isOpen: this._MapService.isLegendBarOpen, legendDetails: this.legendDetails });
  }

  emitEventChange = _.debounce((event: any) => {
    this.eventChange.next(event);
  }, 300, { leading: true, trailing: false });

  getJobLocationData(): void {
    this.jobLocationData = this._MapService.jobLocationData
      .pipe(
        debounceTime(250),
        map((data: any) => Array.isArray(data) ? data : (_.isPlainObject(data) && data?.data && Array.isArray(data?.data)) ? data?.data : data),
        map((jobData: any) => jobData.filter((jobDetails: any) => this.utilityService.isValidGeoCords(jobDetails?.customer_address?.geo_cordinates) && !(this.enableDrawToCreateRoute && (jobDetails?.route || jobDetails?.route?.route_uid))))
      )
      .subscribe({
        next: (res) => {
          this.updateLegendDetails('jobs', res);
          if (this.module === 'JOB') {
            this.jobLocation = res;
            this.activeGeoCords = res[0]?.customer_address?.geo_cordinates;
            this.map.setView([this.activeGeoCords[0], this.activeGeoCords[1]], 12);
            this.plotJobPolyLine();
          }
          const newJobMarkersMap = new Map<string, any>();
          res.forEach((jobDetails: any) => newJobMarkersMap.set(jobDetails.job_uid, jobDetails));
          const markersToRemove = [];
          this.jobMarkersMap.forEach((existingMarker, jobUid) => {
            if (!newJobMarkersMap.has(jobUid)) {
              markersToRemove.push(existingMarker);
              this.jobMarkersMap.delete(jobUid);
            }
          });

          const markersToAdd = [];
          newJobMarkersMap.forEach((jobDetails, jobUid) => {
            const existingMarker = this.jobMarkersMap.get(jobUid);
            if (existingMarker) {
              if (existingMarker?.options?.job?.updated_at !== jobDetails?.updated_at ||
                !_.isEqual(existingMarker?.options?.job?.color_profile, jobDetails?.color_profile)) {
                markersToRemove.push(existingMarker);
                this.jobMarkersMap.delete(jobUid);
                const newMarker = this.createJobMarker(jobDetails)
                if (newMarker) {
                  if (this.nearbyConfig.enable && this.nearbyZone.fromModule === 'JOB' && this.nearbyZone?.eventDetails?.job_uid === jobDetails?.job_uid) {
                    return;
                  }
                  markersToAdd.push(this.createJobMarker(jobDetails));
                }
              }
            } else {
              const newMarker = this.createJobMarker(jobDetails);
              if (newMarker) {
                if (this.nearbyConfig.enable && this.nearbyZone.fromModule === 'JOB' && this.nearbyZone?.eventDetails?.job_uid === jobDetails?.job_uid) {
                  return;
                }
                markersToAdd.push(this.createJobMarker(jobDetails));
              }
            }
          });

          if (markersToRemove?.length) {
            const layerGroupToRemove = L.layerGroup(markersToRemove);
            this.jobLayerGroup.removeLayer(layerGroupToRemove);
            this.markerCluster.removeLayer(layerGroupToRemove);
          }

          if (markersToAdd?.length) {
            const newLayerGroup = L.layerGroup(markersToAdd);
            this.jobLayerGroup.addLayer(newLayerGroup);
            this.markerCluster.addLayer(newLayerGroup);
          }

          if (this.map.hasLayer(this.markerCluster)) {
            this.markerCluster.refreshClusters([...markersToAdd, ...markersToRemove]);
          } else {
            this.map.addLayer(this.markerCluster);
          }
          this._MapService.showOnMap.next({ module: 'JOBS', eventUid: this._MapService.openTooltip.jobUid });
        },
        error: (err) => {
          if (err?.data?.message) { }
        }
      });
  }

  createJobMarker(jobDetails: any): any {
    const coordinates = jobDetails?.customer_address?.geo_cordinates;
    const markerIcon = this.isDispatch ? this.getJobMarkerIcon(jobDetails) : this.defaultJobMarkerIcon;
    const marker = L.marker(coordinates, {
      icon: markerIcon,
      job: jobDetails,
    });

    if (this.isDispatch) {
      marker.on('click', (jobMarkerInstance: any) => {
        if (!jobMarkerInstance.target.getPopup()) {
          this.setJobDetailsTooltipContent(jobMarkerInstance, jobDetails, { showFindLiveTechBtn: this._dispatchBoardService.shouldDisplayLiveTechButtonInMap });
        }
        this._MapService.openTooltip.jobUid = null;

        const popup = jobMarkerInstance.target.getPopup();
        popup.on('remove', (removedMarker: any) => {
          const jobUid = removedMarker.target?.options?.job?.job_uid;
          if (!this.customJobSelection.enable || !this.customJobSelection.selectedJobAndMarker?.[jobUid]) {
            jobMarkerInstance.target.unbindPopup();
          }
        });

        if (this.customJobSelection.enable) {
          this.drawOnMapNavbarData.toggleNavBar = true;
          this.addOrRemoveSelectedJob(jobMarkerInstance);
        } else {
          this.jobSelected.emit(jobDetails);
        }
      });

      marker.on('mouseover', (jobMarkerInstance: any) => {
        if (this.customJobSelection.enable) {
          if (!jobMarkerInstance.target.getPopup()) {
            this.setJobDetailsTooltipContent(jobMarkerInstance, jobDetails);
          } else {
            jobMarkerInstance.target.openPopup();
          }
        }
      });

      marker.on('mouseout', (jobMarkerInstance: any) => {
        if (this.customJobSelection.enable) {
          jobMarkerInstance.target.closePopup();
        }
      });
    } else {
      const markerPopup = this.compilePopup(JobPopupComponent, (c) => {
        c.instance.data = jobDetails;
        c.instance.timezone = this.timezone;
      });
      const popup = R.responsivePopup({ minWidth: 280, offset: [5, -35],  autoPan: true }).setContent(markerPopup);

      marker.bindPopup(popup).on('popupopen', () => {
        this.jobSelected.emit(jobDetails);
      });
    }

    this.jobMarkersMap.set(jobDetails?.job_uid, marker);
    this.jobGroupsMarker.push(marker);
    return marker;
  }

  openSpecificJobMarkerPopup(marker: L.Marker | null): void {
    if (!marker) {
      return;
    }
    this.previousZoom = 18;
    const openAndSetupPopup = () => {
      marker.openPopup();
      // Need to wait for the popup to be opened before setting event listeners
      setTimeout(() => this.attachPopupEventListner('job', marker.getPopup(), marker.options?.job), 500);
    };

    if (this.markerCluster.hasLayer(marker)) {
      this.map.setView(marker.getLatLng(), this.map.getMaxZoom());
      // Need to wait for the map to be zoomed in before showing the popup
      setTimeout(() => {
        this.markerCluster.zoomToShowLayer(marker, () => {
          openAndSetupPopup();
        });
      }, 500);
    } else {
      this.map.panTo(marker.getLatLng());
      openAndSetupPopup();
    }
  }

  preventPopupCloseBtnClick(marker: any): void {
    const popup = marker.getPopup();
    if (popup) {
      popup.on('remove', () => {
        marker.unbindPopup();
      });
      const popupElement = popup.getElement();
      if (popupElement) {
        const closeButton = popupElement.querySelector('.leaflet-popup-close-button');
        if (closeButton) {
          if (marker._closeButtonHandler) {
            closeButton.removeEventListener('click', marker._closeButtonHandler);
          }
          marker._closeButtonHandler = (event: MouseEvent): any => this.handleCloseButtonClick(event, marker);
          closeButton.addEventListener('click', marker._closeButtonHandler);
        }
      }
    }
  }

  handleCloseButtonClick = (event: MouseEvent, marker: any): void => {
    event.stopPropagation();
    event.preventDefault();
    if (!marker) {
      this._MapService.openTooltip.jobUid = null;
      this._MapService.openTooltip.routeUid = null;
    }
    if (marker?.options?.job?.job_uid === this._MapService.openTooltip.jobUid) {
      this._MapService.openTooltip.jobUid = null;
    }
    if (marker?.options?.route?.route_uid === this._MapService.openTooltip.routeUid) {
      this._MapService.openTooltip.routeUid = null;
    }
  };

  getPropertyLocationData(): void {
    this.propertyLocationData = this._MapService.propertyLocationData
    .pipe(map((res: any) => res.filter((data: any) => this.utilityService.isValidGeoCords(data?.property_address?.geo_cordinates))))
    .subscribe({
      next: (res) => {
        if (res) {
          this.updateLegendDetails('properties', res);
          const newPropertyMarkersMap = new Map<string, any>();
          res.forEach((propertyDetails: any) => newPropertyMarkersMap.set(propertyDetails.property_uid, propertyDetails));
  
          const markersToRemove = [];
          this.propertyMarkersMap.forEach((existingMarker, propertyUid) => {
            if (!newPropertyMarkersMap.has(propertyUid)) {
              markersToRemove.push(existingMarker);
              this.propertyMarkersMap.delete(propertyUid);
            }
          });
  
          const markersToAdd = [];
          newPropertyMarkersMap.forEach((propertyDetails, propertyUid) => {
            const existingMarker = this.propertyMarkersMap.get(propertyUid);
            if (existingMarker) {
              if (existingMarker?.options?.property?.updated_at !== propertyDetails?.updated_at ||
                !_.isEqual(existingMarker?.options?.property?.color_profile, propertyDetails?.color_profile)
              ) {
                markersToRemove.push(existingMarker);
                this.propertyMarkersMap.delete(propertyUid);
                const newMarker = this.createPropertyMarker(propertyDetails);
                if (newMarker) {
                  markersToAdd.push(newMarker);
                }
              }
            } else {
              const newMarker = this.createPropertyMarker(propertyDetails);
              if (newMarker) {
                markersToAdd.push(newMarker);
              }
            }
          });
  
          if (markersToRemove?.length) {
            const layerGroupToRemove = L.layerGroup(markersToRemove);
            this.propertyLayerGroup.removeLayer(layerGroupToRemove);
            this.markerCluster.removeLayer(layerGroupToRemove);
          }
  
          if (markersToAdd?.length) {
            const newLayerGroup = L.layerGroup(markersToAdd);
            this.propertyLayerGroup.addLayer(newLayerGroup);
            this.markerCluster.addLayer(newLayerGroup);
          }
  
          if (this.map.hasLayer(this.markerCluster)) {
            this.markerCluster.refreshClusters();
          } else {
            this.map.addLayer(this.markerCluster);
          }
        }
      },
      error: (err) => {
        if (err?.data?.message) { }
      }
    });
  }

  createPropertyMarker(propertyDetails: any): any {
    if (this.utilityService.isValidGeoCords(propertyDetails?.property_address?.geo_cordinates)) {
      let markerIcon = this.defaultPropertyIcon;
      if (this.colorProfileOptions?.isEnabled && propertyDetails?.color_profile) {
        markerIcon = this._MapService.getCustomColorProfileIcon(propertyDetails);
        if (!markerIcon) {
          markerIcon = this.defaultPropertyIcon;
        }
      }
      const marker = L.marker(propertyDetails?.property_address?.geo_cordinates, {
        icon: markerIcon,
        property: propertyDetails
      });
      marker.on('click', (propertyMarkerInstance: any) => {
        if (!propertyMarkerInstance.target.getPopup()) {
          this.bindMarkerPopup('property', propertyMarkerInstance, propertyDetails);
        }
        const popup = propertyMarkerInstance.target.getPopup();
        popup.on('remove', () => {
          propertyMarkerInstance.target.unbindPopup();
        });
      });
      this.propertyMarkersMap.set(propertyDetails.property_uid, marker);
      return marker;
    }
    return null;
  }

  getAssetLocationData(): void {
    this.assetLocationData = this._MapService.assetLocationData
      .pipe(
        map((res: any) => res.filter((data: any) => this.utilityService.isValidGeoCords(data?.asset_location?.geo_cordinates)))
      ).subscribe({
        next: (res: any) => {
          if (res) {
            this.updateLegendDetails('assets', res);
            const newAssetMarkersMap = new Map<string, any>();
            res.forEach((assetDetails: any) => newAssetMarkersMap.set(assetDetails.asset_uid, assetDetails));
  
            const markersToRemove = [];
            this.assetMarkersMap.forEach((existingMarker, assetUid) => {
              if (!newAssetMarkersMap.has(assetUid)) {
                markersToRemove.push(existingMarker);
                this.assetMarkersMap.delete(assetUid);
              }
            });
  
            const markersToAdd = [];
            newAssetMarkersMap.forEach((assetDetails, assetUid) => {
              if (this.utilityService.isValidGeoCords(assetDetails?.asset_location?.geo_cordinates)) {
                const existingMarker = this.assetMarkersMap.get(assetUid);
                if (existingMarker) {
                  if (existingMarker?.options?.asset?.updated_at !== assetDetails?.updated_at ||
                    !_.isEqual(existingMarker.options?.asset?.color_profile, assetDetails?.color_profile)) {
                    markersToRemove.push(existingMarker);
                    this.assetMarkersMap.delete(assetUid);
                    const newMarker = this.createAssetMarker(assetDetails)
                    if (newMarker) {
                      markersToAdd.push(newMarker);
                    }
                  }
                } else {
                  const newMarker = this.createAssetMarker(assetDetails)
                  if (newMarker) {
                    markersToAdd.push(newMarker);
                  }
                }
              }
            });
  
            if (markersToRemove?.length) {
              const layerGroupToRemove = L.layerGroup(markersToRemove);
              this.assetLayerGroup.removeLayer(layerGroupToRemove);
              this.markerCluster.removeLayer(layerGroupToRemove);
            }
  
            if (markersToAdd?.length) {
              const newLayerGroup = L.layerGroup(markersToAdd);
              this.assetLayerGroup.addLayer(newLayerGroup);
              this.markerCluster.addLayer(newLayerGroup);
            }
  
            if (this.map.hasLayer(this.markerCluster)) {
              this.markerCluster.refreshClusters();
            } else {
              this.map.addLayer(this.markerCluster);
            }
          }
        },
        error: (err) => {
          if (err?.data?.message) { }
        }
      });
  }

  createAssetMarker(assetDetails: any): any {
    if (this.utilityService.isValidGeoCords(assetDetails?.asset_location?.geo_cordinates)) {
      let markerIcon = this.defaultAssetIcon;
      if (this.colorProfileOptions?.isEnabled && assetDetails?.color_profile) {
        markerIcon = this._MapService.getCustomColorProfileIcon(assetDetails);
        if (!markerIcon) {
          markerIcon = this.defaultAssetIcon;
        }
      }
      const marker = L.marker(assetDetails?.asset_location?.geo_cordinates, {
        icon: markerIcon,
        asset: assetDetails
      });
      marker.on('click', (assetMarkerInstance: any) => {
        if (!assetMarkerInstance.target.getPopup()) {
          this.bindMarkerPopup('asset', assetMarkerInstance, assetDetails);
        }
        const popup = assetMarkerInstance.target.getPopup();
        popup.on('remove', () => {
          assetMarkerInstance.target.unbindPopup();
        });
      });
      this.assetMarkersMap.set(assetDetails.asset_uid, marker);
      return marker;
    }
    return null;
  }

  createEmployeeMarker(data: any): any {
    if (data?.location_data?.latitude && data?.location_data?.longitude) {
      const icon = L.divIcon({
        className: 'custom-div-icon',
        html: this._MapService.getEmployeeIcon(data, false),
        iconSize: [24, 42],
        iconAnchor: [15, 42]
      });
      const lat = typeof data.location_data.latitude === 'string' ? parseFloat(data.location_data.latitude) : data.location_data.latitude;
      const lng = typeof data.location_data.longitude === 'string' ? parseFloat(data.location_data.longitude) : data.location_data.longitude;
      const employeeMarkerLatLng = this.getEmployeeMarkerGeoCords(lat, lng);
      const marker = L.marker(employeeMarkerLatLng, { icon, user: data });
      marker.originalLatLng = marker.getLatLng();
      
      if (this.isDispatch) {
        const markerEventHandlers = {
          mouseoverHandler: null as any,
          clickHandler: null as any
        };
        
        markerEventHandlers.mouseoverHandler = (userMarkerInstance: any) => {
          if (this.nearbyConfig?.enable && this.nearbyZone.toModule === 'USER') {
            if (this.nearbyZone.polylineRef) {
              this.map.removeLayer(this.nearbyZone.polylineRef);
              this.nearbyZone.polylineRef = null;
            }
            
  
            if (!userMarkerInstance.target.getPopup() || !userMarkerInstance.target.isPopupOpen()) {
              const userMarker = this.bindMarkerPopup('user', userMarkerInstance, data, true, {
                showCreateJob: false,
                showAssignJob: true,
                showDistance: true,
                distance: null,
                time: null,
                showConflict: this._dispatchBoardService.companyConfig.orgConfigJobTimeoffAlert && (this.nearbyZone.fromModule === 'JOB' && this.nearbyZone?.eventDetails?.scheduled_start_time),
                conflictLoading: true,
                className: 'custom-user-popup',
                jobDetails: this.nearbyZone.fromModule === 'JOB' ? this.nearbyZone.eventDetails : null
              });
  
              if (userMarker) {
                this.setAdditionalMarkerConfig('user', 'updateDistance', userMarker, data, {
                  jobDetails: this.nearbyZone.fromModule === 'JOB' ? this.nearbyZone.eventDetails : null, className: 'custom-user-popup'
                });
                this.bindSafeHoverPopupBehaviour(userMarker.target, this.map);
              }
  
              const popup = userMarkerInstance.target.getPopup();
              if (popup && !popup._isRemoveHandlerSet) {
                popup.on('remove', () => {
                  if (this.nearbyZone.polylineRef) {
                    this.map.removeLayer(this.nearbyZone.polylineRef);
                    this.nearbyZone.polylineRef = null;
                  }
                });
                popup._isRemoveHandlerSet = true;
              }
            } else {
              this.setAdditionalMarkerConfig('user', 'updateDistance', userMarkerInstance, data, {
                jobDetails: this.nearbyZone.fromModule === 'JOB' ? this.nearbyZone.eventDetails : null, className: 'custom-user-popup'
              });
            }
          } else {
            if (userMarkerInstance.target.isPopupOpen() && !this.nearbyConfig?.enable) {
              userMarkerInstance.target.closePopup();
            }
          }
        };
        
        markerEventHandlers.clickHandler = (userMarkerInstance: any) => {
          if (!this.nearbyConfig?.enable) {
            if (userMarkerInstance.target.getPopup()) {
              userMarkerInstance.target.unbindPopup();
            }
            this.removeHoverBehavior(userMarkerInstance.target);
            this.bindMarkerPopup('user', userMarkerInstance, data, true, {
              showCreateJob: true,
              showAssignJob: false,
              showDistance: false,
              showConflict: false,
              className: 'custom-user-popup'
            });
  
            const popup = userMarkerInstance.target.getPopup();
            if (popup) {
              popup.on('remove', () => {
                userMarkerInstance.target.unbindPopup();
              });
            }
          }
        };
        
        marker.on('mouseover', markerEventHandlers.mouseoverHandler);
        marker.on('click', markerEventHandlers.clickHandler);
        (marker as any)._eventHandlers = markerEventHandlers;
      } else {
        const markerPopup: any = this.compilePopup(EmployeePopupComponent, (c) => {
          c.instance.data = data;
        });
  
        const popup = R.responsivePopup({
          minWidth: 320,
          offset: [5, -35]
        }).setContent(markerPopup);
  
        marker.bindPopup(popup);
      }
      
      this.employeeMarkersMap.set(data?.user_uid, marker);
      return marker;
    }
    return null;
  }

  updateMarkerListeners(): void {
    if (this.employeeMarkersMap) {
      this.employeeMarkersMap.forEach((marker, uid) => {
        if (marker && (marker as any)._eventHandlers) {
          if (marker.hasEventListeners('mouseover')) {
            marker.off('mouseover', (marker as any)._eventHandlers.mouseoverHandler);
          }
          if (marker.hasEventListeners('click')) {
            marker.off('click', (marker as any)._eventHandlers.clickHandler);
          }
          this.removeHoverBehavior(marker);
          if (!this.nearbyConfig?.enable && marker.getPopup()) {
            const popupType = marker.getPopup()._popupType;
            if (popupType === 'nearbyPopup') {
              marker.unbindPopup();
            }
          }

          if (!this.nearbyConfig?.enable) {
            if ((marker as any).__hoverBehavior) {
              const behavior = (marker as any).__hoverBehavior;
              clearTimeout(behavior.closeTimeout);
              delete (marker as any).__hoverBehavior;
            }

            if (marker.isPopupOpen()) {
              marker.closePopup();
            }

            if (this.nearbyZone.currentActiveMarker === marker) {
              this.nearbyZone.currentActiveMarker = null;
            }
          }

          marker.on('mouseover', (marker as any)._eventHandlers.mouseoverHandler);
          marker.on('click', (marker as any)._eventHandlers.clickHandler);
        }
      });
    }
  }

  cleanupAllHoverBehaviors(): void {
    if (this.employeeMarkersMap) {
      this.employeeMarkersMap.forEach((marker) => {
        if (marker) {
          this.removeHoverBehavior(marker);
        }
      });
    }

    if (this.nearbyZone.polylineRef) {
      this.map.removeLayer(this.nearbyZone.polylineRef);
      this.nearbyZone.polylineRef = null;
      this.nearbyZone.currentPolylineCacheId = null;
    }
    this.nearbyZone.currentActiveMarker = null;
  }

  removeHoverBehavior(marker: L.Marker): void {
    if (!marker) return;

    if ((marker as any).__hoverBehavior) {
      const existing = (marker as any).__hoverBehavior;
      if (existing.destroy) {
        existing.destroy();
      }
      if (existing.closeTimeout) {
        clearTimeout(existing.closeTimeout);
      }

      if (existing.mouseoverHandler) {
        marker.off('mouseover', existing.mouseoverHandler);
      }
      if (existing.mouseoutHandler) {
        marker.off('mouseout', existing.mouseoutHandler);
      }

      if (existing.popupElement) {
        if (existing.mouseenterHandler) {
          existing.popupElement.removeEventListener('mouseenter', existing.mouseenterHandler);
        }
        if (existing.mouseleaveHandler) {
          existing.popupElement.removeEventListener('mouseleave', existing.mouseleaveHandler);
        }
      }

      delete (marker as any).__hoverBehavior;
    }
    if (marker.hasEventListeners('mouseout')) {
      marker.off('mouseout');
    }
    if (marker.hasEventListeners('mouseover')) {
      marker.off('mouseover');
    }

    if (marker.isPopupOpen()) {
      marker.closePopup();
    }

    if (this.nearbyZone.polylineRef) {
      this.map.removeLayer(this.nearbyZone.polylineRef);
      this.nearbyZone.polylineRef = null;
      this.nearbyZone.currentPolylineCacheId = null;
    }

    if (this.nearbyZone.currentActiveMarker === marker) {
      this.nearbyZone.currentActiveMarker = null;
    }
  }

  getEmployeeLocationData(): void {
    this.employeeLocationData = this._MapService.employeeLocationData
      .pipe(
        map((res: any) => res.filter((data: any) => data?.location_data?.latitude && data?.location_data?.longitude))
      )
      .subscribe({
        next: (res) => {
          if(this.module == 'JOB') {
            this.employeeLocation = res;
            this.plotJobPolyLine();
          }
          const newEmployeeMarkersMap = new Map<string, any>();
          const markersToRemove: L.Marker[] = [];
          const markersToAdd: L.Marker[] = [];
          res?.forEach((data: any) => newEmployeeMarkersMap.set(data.user_uid, data));
          this.employeeMarkersMap?.forEach((existingMarker, userUid) => {
            if (!newEmployeeMarkersMap.has(userUid)) {
              markersToRemove.push(existingMarker);
              this.employeeMarkersMap.delete(userUid);
            }
          });
          newEmployeeMarkersMap.forEach((data, userUid) => {
            const existingMarker = this.employeeMarkersMap.get(userUid);
            if (existingMarker) {
              if ((existingMarker.options.user?.location_data?.track_time !== data?.location_data?.track_time) || ((existingMarker.options.user?.location_data?.latitude !== data?.location_data?.latitude) || (existingMarker.options.user?.location_data?.longitude !== data?.location_data?.longitude))) {
                markersToRemove.push(existingMarker);
                this.employeeMarkersMap.delete(userUid);
                const newMarker = this.createEmployeeMarker(data);
                if (newMarker) {
                  markersToAdd.push(newMarker);
                }
              }
            } else {
              const newMarker = this.createEmployeeMarker(data);
              if (newMarker) {
                markersToAdd.push(newMarker);
              }
            }
          });
            if (markersToRemove.length) {
            markersToRemove.forEach(marker => {
              this.employeeLayerGroup.removeLayer(marker);
            });
            }
            if (markersToAdd.length) {
            markersToAdd.forEach(marker => {
              this.employeeLayerGroup.addLayer(marker);
            });
            }
            if (this.employeeLayerGroup.getLayers().length > 0) {
            if (!this.map.hasLayer(this.employeeLayerGroup)) {
              this.map.addLayer(this.employeeLayerGroup);
            }
            } else if (this.map.hasLayer(this.employeeLayerGroup)) {
            this.map.removeLayer(this.employeeLayerGroup);
            }
        },
        error: (err) => {
          if (err?.data?.message) {
          }
        }
      });
  }

  setMapView(data: any): void {
    if (data?.latitude && data?.longitude && !this.isDispatch) {
      this.map.setView([data.latitude, data.longitude - 0 + 0.035], 13);
    } else if (data?.latitude && data?.longitude && this.isDispatch) {
      this.map.setView([data.latitude, data.longitude], 16);
    }
  }

  getPreview(): void {
    this.drawerPreviewUid = this._MapService.previewUid.subscribe((res: any) => {
      if(this.isDispatch) {
        this._MapService.openPreviewDetailsInDispatchBoard.next({ openDrawer: !!res, previewUid: res['uid'], module: res['module'] });
        return;
      }
      if (res?.data) {
        this.currentRoute = res?.data;
        this.openRouteDetails = true;
        return;
      }
      if (res === false) {
        this.openDrawer = false;
      } else {
        this.moduleUid = res['uid'];
        this.drawerModule = res['module'];
        if (res?.canEdit) {
          this.previewOptions['allowToEdit'] = true;
        } else {
          this.previewOptions['allowToEdit'] = false;
        }
        this.previewOptions['menuOptions'] = {
          viewDetails: true,
          delete: false,
          clone: false
        };
        this.openDrawer = true;
      }
    });
  }

  getSidebarState(): void {
    this.sidebarState = this._MapService.sidebar.subscribe((res) => {
      if (res === false) { setTimeout(() => { this.map.invalidateSize(); }, 400); }
    });
  }

  getMarkerState(): void {
    this.markerState = this._MapService.markerStatus.subscribe((res) => {
      for (const key in res.modules) {
        if (key === 'EMPLOYEE' && res.current_tab !== 'EMPLOYEE') {
          if (res.states[key]) {
            this.markerCluster.addLayers(this.employeeGroupsMarker);
            // this.markerCluster.refreshClusters();
          } else {
            if (this.employeeLayerGroup) {
              this.markerCluster.removeLayer(this.employeeGroupsMarker);
              this.markerCluster.removeLayer(this.employeeLayerGroup);
              // this.markerCluster.refreshClusters();
            }
          }
        } else if (key === 'JOBS' && res.current_tab !== 'JOBS') {
          if (res.states[key]) {
            this.markerCluster.addLayers(this.jobGroupsMarker);
          } else {
            if (this.jobLayerGroup) {
              this.markerCluster.removeLayer(this.jobGroupsMarker);
              this.markerCluster.removeLayer(this.jobLayerGroup);
            }
          }
        }
        else if (key === 'ASSETS' && res.current_tab !== 'ASSETS') {
          if (res.states[key]) {
            this.markerCluster.addLayers(this.assetGroupsMarker);
          } else {
            if (this.assetLayerGroup) {
              this.markerCluster.removeLayer(this.assetGroupsMarker);
              this.markerCluster.removeLayer(this.assetLayerGroup);
            }
          }
        }
        else if (key === 'PROPERTY' && res.current_tab !== 'PROPERTY') {
          if (res.states[key]) {
            this.markerCluster.addLayers(this.propertyGroupsMarkers);
          } else {
            if (this.propertyLayerGroup) {
              this.markerCluster.removeLayer(this.propertyGroupsMarkers);
              this.markerCluster.removeLayer(this.propertyLayerGroup);
            }
          }
        }
        else if (key === 'ORGANIZATION' && res.current_tab !== 'ORGANIZATION') {
          if (res.states[key]) {
            this.markerCluster.addLayers(this.organizationGroupsMarker);
          } else {
            if (this.organizationLayerGroup) {
              this.markerCluster.removeLayer(this.organizationGroupsMarker);
              this.markerCluster.removeLayer(this.organizationLayerGroup);
            }
          }
        }
        else if (key === 'CUSTOMER' && res.current_tab !== 'CUSTOMER') {
          if (res.states[key]) {
            this.markerCluster.addLayers(this.customerGroupsMarker);
          } else {
            if (this.customerLayerGroup) {
              this.markerCluster.removeLayer(this.customerGroupsMarker);
              this.markerCluster.removeLayer(this.customerLayerGroup);
            }
          }
        }
        else if (key === 'ROUTES' && res.current_tab !== 'ROUTES') {
          if (res.states[key]) {
            if (this.routeLayerGroup) {
              this.map.addLayer(this.routeLayerGroup);
            }
          } else {
            if (this.routeLayerGroup) {
              this.map.removeLayer(this.routeLayerGroup);
            }
          }
        }
      }
    });
  }

  isMarkerInsidePolygon(latLng: any, polygon: any): boolean {
    const x = latLng.lat, y = latLng.lng;
    let inside = false;
    const polyPoints = polygon.getLatLngs()[0];
    for (let i = 0, j = polyPoints.length - 1; i < polyPoints.length; j = i++) {
      const xi = polyPoints[i].lat, yi = polyPoints[i].lng;
      const xj = polyPoints[j].lat, yj = polyPoints[j].lng;
  
      const intersect = ((yi > y) !== (yj > y)) &&
        (x < ((xj - xi) * (y - yi)) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }

  isMarkerInsideCircle(marker: any, circle: any): boolean {
    const markerLatLng = marker.getLatLng();
    const circleCenter = circle.getLatLng();
    const radius = circle.getRadius();    
    const distanceToCenter = markerLatLng.distanceTo(circleCenter);
    return distanceToCenter <= radius;
  }

  //Routes
  getRouteJobMarker(routeDetails: any, data: any, jobCount: number): void {
    //Initializing Icon
    const color = routeDetails?.color?.hex ? '#' + routeDetails.color.hex : routeDetails?.color;
    const icon = L.divIcon({
      className: 'custom-div-icon',
      html: this._MapService.getRouteJobIcon(color, jobCount),
      iconSize: [40, 52],
      iconAnchor: [15, 42]
    });

    //Creating marker and binding events
    const [routeJobLat, routeJobLng] = data?.geo_cords;
    const jobGeoCords = this.getRouteMarkerGeoCords(routeJobLat, routeJobLng);
    const routeJobMarker = L.marker(jobGeoCords, {
      icon: icon,
      isRouteJob: true,
      job: data?.job,
      jobUid: data?.job_uid
    });
    routeJobMarker.on('click', (jobMarkerInstance: any) => {
      const jobDetails: any = jobMarkerInstance.target.options?.job;
      const jobUid: any = jobMarkerInstance.target.options?.jobUid;
      if (!jobDetails && jobUid) {
        const loadingPopupContent: string = `<div class='flex items-center justify-center'>${this.utilityService.getLocaleValue('text.loading', 'Loading')}</div>`;
        jobMarkerInstance.target.bindPopup(
          R.responsivePopup({
            minWidth: 250,
            minHeight: 250,
            offset: L.point(5, -35),
            autoPan: true,
            autoPanPadding: [30, 55]
          }).setContent(loadingPopupContent),
          {
            closeButton: true,
            job: jobDetails,
            jobUid: data?.job_uid
          }
        );
        jobMarkerInstance.target.openPopup();
        const popup = jobMarkerInstance.target.getPopup();
        if (popup) {
          const popupElement = popup.getElement();
          if (popupElement) {
            const closeButton = popupElement.querySelector('.leaflet-popup-close-button');
            if (closeButton) {
              closeButton.removeEventListener('click', this.handleCloseButtonClick);
              closeButton.addEventListener('click', this.handleCloseButtonClick);
            }
          }
        }
        this._dispatchBoardService.getJobDetails(jobUid).subscribe((response: any) => {
          const popupContent: string = this._dispatchTemplateBoardService.getJobDetailsTemplate(response?.data, 'DAY', { map: { enable_map_view: true } }, true, { showRouteJobNumber: true, color: color, jobCount: jobCount });
          jobMarkerInstance.target.getPopup().setContent(popupContent);
          jobMarkerInstance.target.options['job'] = response?.data;
        });
      }
      else {
        jobDetails['route'] = routeDetails;
        if (!jobMarkerInstance.target.getPopup()) {
          this.setJobDetailsTooltipContent(jobMarkerInstance, jobDetails, {showRouteJobNumber: true, color: color, jobCount: jobCount});
        }
        const popup = jobMarkerInstance.target.getPopup();
        popup.on('remove', () => {
          jobMarkerInstance.target.unbindPopup();
        });
      }
    });
    routeJobMarker.addTo(this.routeLayerGroup);
  }

  getRouteLocationData(): void {
    this.routeLocationData = this._MapService.routeLocationData
      .pipe(
        catchError(() => of([])),
        debounceTime(250),
        distinctUntilChanged((prevObj: any, currObj: any) => {
          const prev: any = prevObj?.data;
          const curr: any = currObj?.data;
          if (currObj?.forceUpdate) { return false; }
          if (currObj?.state === 'details' || currObj?.state === 'listing' || currObj === 'UPDATE_MAP_SETTINGS') { return false; }
          if (!prev && !curr) { return true; };
          if (!prev || !curr) { return false; }
          if (prev?.length !== curr?.length) { return false; }
          if (prev?.length === 0 && curr?.length === 0) { return true; };
          return prev.every((prevItem: any, index: any) => {
            const currItem = curr[index];
            if (!prevItem || !currItem) { return false; };
            if (prevItem?.route_uid !== currItem?.route_uid) { return false; };
            return _.isEqual(prevItem, currItem);
          });
        })
      )
      .subscribe({
        next: (res: any) => {
          if (this.routeLayerGroup) {
            this.map.removeLayer(this.routeLayerGroup);
            this.routeLayerGroup = '';
          }
          if (res?.data) {
            this.masterRouteCopy = res;
          }
          if (res === 'ADD_ROUTE') {
            res = {
              data: this.masterRouteCopy?.data,
              state: this.masterRouteCopy?.state || ''
            };
          } else if (res === 'REMOVE_ROUTE') {
            if (this.masterRouteCopy?.state !== 'details') {
              res = {
                data: [],
                state: this.masterRouteCopy?.state || ''
              };
            } else {
              res = {
                data: this.masterRouteCopy?.data,
                state: this.masterRouteCopy?.state || ''
              };
            }
          }
          else if (res === 'UPDATE_MAP_SETTINGS') {
            this.mapSettings = this._localStorageService.getLocalStorage('map_settings');
            res = this.masterRouteCopy;
          }
          if (res?.state === 'listing') {
            this.allRoutes = res?.data;
            const drawer = this._zuperDrawerService.getComponent('routeDetails');
            if (drawer && res?.drawerClosed) {
              drawer.close();
              this.currentRoute = null;
              this.openRouteDetails = false;
            }
          }
          const routes = res?.data || [];
          if (this.mapSettings?.overlay_routes || (res?.state === 'details') || this.isDispatch) {
            this.addRouteToMap(routes);
          }
        },
        error: (err: any) => {
          if (err?.data?.message) {
          }
        }
      });
  }

  addRouteToMap(routes: any): void {
    this.routeLayerGroup = L.layerGroup();
    this.map.addLayer(this.routeLayerGroup);
    this.routeHomeMarkersMap.clear();
    this.routeMarkerLocations.clear();
    routes?.forEach(async (route: any) => {
      if (!route?.showShimmer) {
        await this.getRoute(route?.start_location, route?.end_location, route);
      }
    });
    if (this._MapService.openTooltip.routeUid) {
      this._MapService.showOnMap.next({ module: 'ROUTES', eventUid: this._MapService.openTooltip.routeUid }); 
    }
  }

  getServiceTerritoryLocationData(): void {
    this.serviceTerritoryLocationData = this._MapService.serviceTerritoryLocationData
      .pipe(
      distinctUntilChanged((prev: any, curr: any): boolean => {
        if (prev.length !== curr.length) { return false; }
        else if(this.territoryGroup?.length) { return true; }
      }))
      .subscribe((res: any) => {
      this.serviceTerritory = res;
      this.serviceTerritory = this.serviceTerritory.filter((territory: any) => (territory?.territory_type !== 'ZIPCODE' && territory?.is_active));
      if (this.territoryLayerGroup) {
        this.map.removeLayer(this.territoryLayerGroup);
        this.territoryLayerGroup = '';
      }
      if (this.serviceTerritory?.length) {
        this.territoryGroup = [];
        this.serviceTerritory.forEach((territory: any) => {
        let marker: any;
        try {
          if (territory?.territory_type === 'GEOFENCE' && territory?.territory_coordinates?.length === 2 && !territory?.territory_coordinates.includes(null)) {
            marker = L.rectangle(territory?.territory_coordinates, { color: territory?.territory_color });
          } else if (territory?.territory_type === 'GEOFENCE' && territory?.territory_coordinates?.length > 2 && !territory?.territory_coordinates.includes(null)) {
            marker = L.polygon(territory?.territory_coordinates, { color: territory?.territory_color });
          } else if (territory?.territory_type === 'RADIUS' && territory?.territory_radius?.geo_cordinates?.length > 0 && territory?.territory_radius?.radius && !territory?.territory_radius?.geo_cordinates.includes(null)) {
            marker = L.circle(territory?.territory_radius?.geo_cordinates, { radius: territory?.territory_radius?.radius, color: territory?.territory_color });
          }
        } catch (error) {
          return; // Skip the marker if an error occurs
        }
        if (marker) {
          marker['target'] = marker;
          marker.on('click', (territoryMarkerInstance: any) => {
          if (!territoryMarkerInstance.target.getPopup()) {
            this.bindMarkerPopup('territory', territoryMarkerInstance, territory);
          }
          const popup = territoryMarkerInstance.target.getPopup();
          popup.on('remove', () => {
            territoryMarkerInstance.target.unbindPopup();
          });
          });
          this.territoryGroup.push(marker);
        }
        });
        this.territoryLayerGroup = L.layerGroup(this.territoryGroup);
        this.map.addLayer(this.territoryLayerGroup);
      }
      });
  }

  toggleTerritoryDrawer(): void {
    this.territoryDrawer = this._MapService.legendDrawerToggler.subscribe(
      (res: any) => {
        if(res === 'open'){
          this._zuperDrawerService.getComponent('legendDrawer').open();
        }
      }
    );
  }

  toggleNewJobDrawer(): void {
    this.jobDrawer = this._MapService.newJobDrawerToggler.subscribe(
      (res: any) => {
        if (res) {
          if (res?.module === 'EMPLOYEE') {
            this.jobObject['user'] = res?.data;
          } else {
            if (res?.data?.organization) {
              this.jobData['organization'] = res?.data?.organization;
              if (res?.data?.organization?.organization_address) {
                this.jobData['customer_billing_address'] = res?.data?.organization?.organization_address;
              }
            }
            if (res?.data?.customer_organization) {
              this.jobData['organization'] = res?.data?.customer_organization;
              if (res?.data?.customer_organization?.organization_address) {
                this.jobData['customer_billing_address'] = res?.data?.customer_organization?.organization_address;
              }
            }
            if (res?.data?.customer) {
              this.jobData['customer'] = res?.data?.customer;
              if (res?.data?.customer?.customer_address) {
                this.jobData['customer_address'] = res?.data?.customer?.customer_address;
              }
            }

            if (res?.data?.property) {
              this.jobData['property'] = res?.data?.property;
              if (res?.data?.property?.property_address) {
                this.jobData['customer_address'] = res?.data?.property?.property_address;
              }
            }
            if (res?.module === 'ASSET') {
              this.jobData['asset'] = res?.data;
            }
            if (res?.module === 'PROPERTY') {
              this.jobData['property'] = res?.data;
            }
            if (res?.module === 'CUSTOMER') {
              this.jobData['customer'] = res?.data;
            }
            if (res?.module === 'ORGANIZATION') {
              this.jobData['organization'] = res?.data;
              if (res?.data?.organization?.organization_address) {
                this.jobData['customer_address'] = res?.data?.organization?.organization_address;
              }
              if (res?.data?.organization?.organization_billing_address) {
                this.jobData['customer_billing_address'] = res?.data?.organization?.organization_billing_address;
              }
            }

          }
          this.openJob = true;
        }
      }
    );
  }

  getJobFormResult(data: any): void {
    if (data?.isDrawerClosed) {
      this.openJob = false;
      this.jobObject = {};
      this.jobData = {};
    }
    if (data?.action === 'ADVANCED_JOB' && data?.job) {
      const job: dataObj = { ...data?.job, action: 'clone', isDialog: true };
      this.zuperDialogService.openCustom(JobFormComponent, {
        data: job,
        extraClass: 'advanced-job-dialog'
      });
    }
  }

  closeLegendDrawer(): void {
    this._zuperDrawerService.getComponent('legendDrawer').close();
  }

  getRelativeMarkerOffset(index: number): [number, number] {
    const offsetStep = 0.00005;
    return [index * offsetStep, -index * offsetStep];
  }

  getRelativeEmployeeMarkerOffset(index: number): [number, number] {
    const offsetStepLat = -0.001;
    const offsetStepLng = -0.0006;
    return [index * offsetStepLat, index * offsetStepLng];
  }

  getRouteMarkerGeoCords(lat: number, lng: number): [number, number] {
    if (!this.utilityService.isValidGeoCords([lat, lng])) {
      return null;
    }
    const locationKey = `${lat.toFixed(5)},${lng.toFixed(5)}`;
    const count = this.routeMarkerLocations.get(locationKey) || 0;
    if (count > 0) {
      const [offsetLat, offsetLng] = this.getRelativeMarkerOffset(count);
      lat += offsetLat;
      lng += offsetLng;
    }
    this.routeMarkerLocations.set(locationKey, count + 1);
    return [lat, lng];
  }
  
  getEmployeeMarkerGeoCords(lat: number, lng: number): [number, number] {
    if (!this.utilityService.isValidGeoCords([lat, lng])) return null;
    const CLUSTERING_THRESHOLD_METERS = 10;
    const nearbyCluster = this.findClusterWithinThreshold(lat, lng, CLUSTERING_THRESHOLD_METERS);
    if (nearbyCluster) {
      const [baseLat, baseLng] = nearbyCluster.baseCoords;
      const markerCount = nearbyCluster.count;
      const [offsetLat, offsetLng] = this.getRelativeEmployeeMarkerOffset(markerCount);
      const finalLat = baseLat + offsetLat;
      const finalLng = baseLng + offsetLng;
      nearbyCluster.count += 1;
      return [finalLat, finalLng];
    } else {
      const locationKey = `${lat.toFixed(5)},${lng.toFixed(5)}`;
      const newCluster = { baseCoords: [lat, lng] as [number, number], count: 1 };
      this.employeeMarkerClusters.set(locationKey, newCluster);
      return [lat, lng];
    }
  }

  findClusterWithinThreshold(lat: number, lng: number, thresholdMeters: number): any {
    for (const [locationKey, clusterInfo] of this.employeeMarkerClusters.entries()) {
      const [clusterLat, clusterLng] = clusterInfo.baseCoords;
      const distanceToCluster = this.calculateDistance(lat, lng, clusterLat, clusterLng);
      if (distanceToCluster <= thresholdMeters) return clusterInfo;
    }
    return null;
  }

  calculateDistance(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const EARTH_RADIUS_METERS = 6371000;
    const deltaLatRadians = this.toRadians(lat2 - lat1);
    const deltaLngRadians = this.toRadians(lng2 - lng1);
    const lat1Radians = this.toRadians(lat1);
    const lat2Radians = this.toRadians(lat2);

    const haversineLat = Math.sin(deltaLatRadians / 2) ** 2;
    const haversineLng = Math.sin(deltaLngRadians / 2) ** 2;
    const haversineFormula = haversineLat + Math.cos(lat1Radians) * Math.cos(lat2Radians) * haversineLng;
    const angularDistance = 2 * Math.atan2(Math.sqrt(haversineFormula), Math.sqrt(1 - haversineFormula));

    return EARTH_RADIUS_METERS * angularDistance;
  }

  toRadians(degrees: number): number {
    return degrees * (Math.PI / 180);
  }

  getEmployeeMarkerGeoCords_PixelBased(lat: number, lng: number): [number, number] {
    if (!this.utilityService.isValidGeoCords([lat, lng])) return null;
    const COORD_THRESHOLD = 0.0001;
    for (const [locationKey, existingCount] of this.employeeMarkerLocations.entries()) {
      const [existingLat, existingLng] = locationKey.split(',').map(Number);
      const latDifference = Math.abs(lat - existingLat);
      const lngDifference = Math.abs(lng - existingLng);
      if (latDifference <= COORD_THRESHOLD && lngDifference <= COORD_THRESHOLD) {
        const [offsetLat, offsetLng] = this.getRelativeEmployeeMarkerOffset(existingCount);
        const finalLat = existingLat + offsetLat;
        const finalLng = existingLng + offsetLng;
        this.employeeMarkerLocations.set(locationKey, existingCount + 1);
        return [finalLat, finalLng];
      }
    }
    const locationKey = `${lat.toFixed(5)},${lng.toFixed(5)}`;
    this.employeeMarkerLocations.set(locationKey, 1);
    return [lat, lng];
  }

  getOffsetPosition(newLatLng: [number, number], existingMarkers: Map<string, [number, number]>, offsetDistance = 0.0001) {
    const matches = [];
    for (const [uid, [lat, lng]] of existingMarkers) {
      if (lat === newLatLng[0] && lng === newLatLng[1]) {
        matches.push({ uid, lat, lng });
      }
    }
    if (matches.length === 1) {
      return [
        newLatLng[0] + offsetDistance,
        newLatLng[1] + offsetDistance
      ];
    }
    return newLatLng;
  }

  async getRoute(origin: any, destination: any, route: any): Promise<void> {

    //Home Marker
    let viaLocation = [];
    if (route?.jobs?.length > 0) {
      viaLocation = route?.jobs.map((job: any) => job?.geo_cords?.join(','));
    }
    viaLocation = _.compact(viaLocation);
    const originIcon = L.divIcon({
      className: 'custom-div-icon',
      html: this._MapService.getHomeIcon(route.color ? route.color : '#1abc9c'),
      iconSize: [30, 42],
      iconAnchor: [15, 42]
    });
    const [routeStartLat, routeStartLng] = route?.start_location?.geo_cords;
    const routeStartGeoCords = this.getRouteMarkerGeoCords(routeStartLat, routeStartLng);
    if (routeStartGeoCords) {
      const homemarker = L.marker(routeStartGeoCords, {
        icon: originIcon,
        route: route
      });
      if (this.isDispatch) {
        homemarker.on('click', (routeHomeMarkerInstance: any) => {
          if (this.drawOnMapNavbarData.selectedPolylinePopupInstance && this.drawOnMapNavbarData.selectedPolylinePopupInstance.getPopup()) {
            this.drawOnMapNavbarData.selectedPolylinePopupInstance.closePopup();
            this.drawOnMapNavbarData.selectedPolylinePopupInstance.unbindPopup();
          }
          this._MapService.openTooltip.routeUid = null;
          if (!routeHomeMarkerInstance.target.getPopup()) {
            this.setRouteHomeTooltipContent(routeHomeMarkerInstance, route);
          }
          const popup = routeHomeMarkerInstance.target.getPopup();
          popup.on('remove', () => {
            routeHomeMarkerInstance.target.unbindPopup();
          });
        });
        homemarker.addTo(this.routeLayerGroup);
        this.routeHomeMarkersMap.set(route?.route_uid, homemarker);
      }
      else {
        const homeMarkerComponent: any = this.compilePopup(OriginDestinationPopupComponent, (c) => { c.instance.data = { type: 'ORIGIN', data: route }; });
        const homeMarkerPopup = R.responsivePopup({ minWidth: 280, offset: [5, -35] }).setContent(homeMarkerComponent);
        homemarker.bindPopup(homeMarkerPopup).addTo(this.routeLayerGroup);
      }
    }

    //Destination Marker
    if (destination?.geo_cords) {
      if (this.isDispatch) {
        const [routeEndLat, routeEndLng] = destination?.geo_cords;
        const routeEndGeoCords = this.getRouteMarkerGeoCords(routeEndLat, routeEndLng);
        if (routeEndGeoCords) {
          const destinationIcon = L.divIcon({
            className: 'custom-div-icon',
            html: this._MapService.getDestinationIcon(route.color ? route.color : '#1abc9c'),
            iconSize: [40, 52],
            iconAnchor: [15, 42]
          });
          const destinationMarker = L.marker(routeEndGeoCords, {
            icon: destinationIcon,
            route: route
          });
          destinationMarker.on('click', (routeDestinationMarkerInstance: any) => {
            if (!routeDestinationMarkerInstance.target.getPopup()) {
              this.setRouteDestinationTooltipContent(routeDestinationMarkerInstance, route);
            }
            const popup = routeDestinationMarkerInstance.target.getPopup();
            popup.on('remove', () => {
              routeDestinationMarkerInstance.target.unbindPopup();
            });
          });
          destinationMarker.addTo(this.routeLayerGroup);
        }
      }
      else {
        const destinationMarkerComponent: any = this.compilePopup(OriginDestinationPopupComponent, (c) => { c.instance.data = { type: 'DESTINATION', data: route }; });
        const detinationMarkerPopup = R.responsivePopup({ minWidth: 280, offset: [5, -35] }).setContent(destinationMarkerComponent);
        const destinationIcon = L.divIcon({
          className: 'custom-div-icon',
          html: this._MapService.getDestinationIcon(route.color ? route.color : '#1abc9c'),
          iconSize: [40, 52],
          iconAnchor: [15, 42]
        });

        const destinationMarker = L.marker(destination?.geo_cords, {
          icon: destinationIcon
        }).bindPopup(detinationMarkerPopup).addTo(this.routeLayerGroup);
      }
    }

    //Jobs Marker
    if (route?.jobs?.length > 0) {
      route.jobs = route.jobs.sort((one: any, two: any) => one?.sequence - two?.sequence);
      route.jobs.forEach((data: any, index: number) => {
        this.getRouteJobMarker(route, data, index + 1);
      });
    }

    const routingParameters = {
      'routingMode': 'fast',
      'transportMode': 'car',
      'origin': origin?.geo_cords?.join(','),
      'spans': 'duration,baseDuration,length',
      'via': new H.service.Url.MultiValueQueryParameter(viaLocation),
      'return': 'polyline',
      'destination': null
    };

    if (destination?.geo_cords) {
      routingParameters['destination'] = destination?.geo_cords?.join(',');
    } else if (viaLocation?.length) {
      routingParameters['destination'] = viaLocation[viaLocation?.length - 1];
    }

    if (!this.utilityService.isEmptyOrUndefined(routingParameters.destination)) {
      let sections: any[] = [];
      if (route?.polyline) {
        sections = route?.polyline || [];
      }
      else {
        const router = this.platform.getRoutingService(null, 8);
        await router.calculateRoute(routingParameters, (data: any) => {
          if (data?.routes[0]?.['sections']) {
            sections = data.routes[0]['sections'];
          }
          else {
            sections = [];
          }
        });
      }
      sections.forEach((section) => {
        if (section?.polyline) {
          const linestring = H.util.flexiblePolyline.decode(section.polyline);
          // const seconds = section.spans[0]['duration'];
          // const hour = Math.floor(seconds/(60*60));
          // const minutes = Math.floor(seconds/60);
          // const popup = R.responsivePopup({ minWidth: 280, offset: [5,-35] }).setContent(`
          //   <p class="text-center">
          //     <span class="font-semibold text-gray-800 text-md">
          //     ETA:
          //     </span>
          //     <span class="text-md">
          //       ${hour ? hour+' Hr(s)' : ''} ${minutes ? minutes+' Min(s)' : ''}
          //     </span>
          //   </p>
          // `);
          // ANIMATED LINE
          const routeColor: string = route.color ? route.color : '#1abc9c';
          const enhancedRouteColor: string = this.utilityService.darkenHex(routeColor, 18);
          const antPolyline = L.polyline(linestring.polyline, {
            'color': routeColor,
            'weight': 5,
          });
          antPolyline.on('mouseover', (event: any) => this.onMouseOver(event, antPolyline, enhancedRouteColor));
          antPolyline.on('mouseout', (event: any) => this.onMouseOut(event, antPolyline, routeColor));
          antPolyline.on('click', (event: any) => this.onPolylineClick(event, antPolyline, route));
          antPolyline.addTo(this.routeLayerGroup);
          // this.map.fitBounds(antPolyline.getBounds(),{
          //   padding: [40, 40]
          // });
          // this.map.setMaxBounds(antPolyline.getBounds());
        }
      });
    }
  }

  onMouseOver(event: L.LeafletEvent, polyline: L.Polyline, color: string): void {
    if (this.isJobSelectedForRouteAssignment) {
      polyline.setStyle({ color: color, weight: 8 });
    }
  }

  onMouseOut(event: L.LeafletEvent, polyline: L.Polyline, color: string): void {
    if (this.isJobSelectedForRouteAssignment) {
      polyline.setStyle({ color: color, weight: 5 });
    }
  }

  onPolylineClick(event: L.LeafletMouseEvent, polyline: L.Polyline, routeDetails: any): void {
    if (this.isJobSelectedForRouteAssignment) {
      if (this.currentPolyline.popup && this.currentPolyline.popup !== polyline) {
        this.currentPolyline.popup.closePopup();
        this.currentPolyline.popup.unbindPopup();
      }
      this.currentPolyline.popup = polyline;
      this.currentPolyline.routeDetails = routeDetails;
      const latlng = event.latlng;
      const popupContent = this._dispatchTemplateBoardService.getRoutePolylineTooltipTemplate(routeDetails, this.drawOnMapNavbarData.selectedJobs?.length || 0, this._dispatchBoardService.selectedTimezone[this._dispatchBoardService.activeDispatchTab]);
      if (!polyline.getPopup()) {
        polyline.bindPopup(popupContent, {
          closeButton: true,
          autoClose: false,
          closeOnClick: false,
          minWidth: 250
        }).openPopup(latlng);
      } else {
        polyline.getPopup()?.setContent(popupContent).setLatLng(latlng).openOn(this.map);
      }
      this.drawOnMapNavbarData.selectedPolylinePopupInstance = polyline;
      this.drawOnMapNavbarData.selectedRoute = routeDetails;
      polyline.off('popupclose');
      polyline.on('popupclose', () => {
        polyline.unbindPopup();
      });

      setTimeout(() => {
        const popup = polyline.getPopup();
        if (popup) {
          const popupElement = popup.getElement();
          if (popupElement) {
            const addJobToRouteButton = popupElement.querySelector('#add-job-to-route-btn');
            const closeButton = popupElement.querySelector('.leaflet-popup-close-button');
            if (addJobToRouteButton) {
              addJobToRouteButton.removeEventListener('click', this.addJobsToRouteClickEvent);
              addJobToRouteButton.addEventListener('click', this.addJobsToRouteClickEvent);
            }
            if (closeButton) {
              closeButton.removeEventListener('click', this.handleCloseButtonClick);
              closeButton.addEventListener('click', this.handleCloseButtonClick);
            }
          }
        }
      });
    }
    if (!polyline.hasEventListeners('popupclose')) {
      polyline.on('popupclose', () => {
        polyline.unbindPopup();
        this.currentPolyline.popup = null;
      });
    }

  }

  showClearSelectionFloatingBtn(): void {
    this.floatingActionButton.showClearBtn = true;
    this.floatingActionButton.showInfo = false;
    this.floatingActionButton.infoMessage = '';
  }

  removeFloatingInfo(): void {
    this.floatingActionButton.showInfo = false;
    this.floatingActionButton.infoMessage = '';
  }

  removeFloatingClearSelection(): void {
    this.floatingActionButton.showClearBtn = false;
  }

  formatJobDetails(jobs: any[]): any[] {
    jobs = _.uniqBy(jobs, 'job_uid');
    jobs = jobs.map((jobDetails: any) => ({
      ...jobDetails,
      name: this._dispatchBoardService.getJobTitle(jobDetails?.prefix, jobDetails?.work_order_number, jobDetails?.job_title),
      startEndTime: this._dispatchBoardService.getStartEndTime(jobDetails?.scheduled_start_time, jobDetails?.scheduled_end_time, true),
      statusFadeColor: this.utilityService.convertHexToRgba(jobDetails?.current_job_status?.status_color),
      assignedToAvatar: this._dispatchTemplateBoardService.getAssignedToAvatarView(jobDetails?.assigned_to || []),
      showDueDate: !jobDetails?.scheduled_start_time,
      dueDate: jobDetails?.due_date ? moment(jobDetails?.due_date).format(this._dispatchBoardService.dateFormat): ''
    }));
    return jobs;
  }

  initRouteJobConfirmationDialogData(selectedJobs: any[]): void {
    this.routeJobConfirmationDialogData.jobs = {};
    selectedJobs.forEach((jobDetails: any) => {
      this.routeJobConfirmationDialogData.jobs[jobDetails?.job_uid] = true;
      const geoCords = jobDetails?.customer_address?.geo_cordinates;
      this.routeJobConfirmationDialogData.geoCords[jobDetails?.job_uid] = geoCords || [];
    });
    this.updateSelectedJobCountInConfirmationDialog();
  }

  updateSelectedJobCountInConfirmationDialog(): void {
    if (!this.routeJobConfirmationDialogData.jobs) {
      this.routeJobConfirmationDialogData.jobs = {};
    }
    this.routeJobConfirmationDialogData.selectedJobCount = Object.values(this.routeJobConfirmationDialogData.jobs).filter(Boolean).length;
  }

  addRouteJobSelectionChange($event: any, jobDetails: any): void {
    this.routeJobConfirmationDialogData.jobs[jobDetails?.job_uid] = $event?.target?.checked ?? false;
    if ($event?.target?.checked) {
      this.routeJobConfirmationDialogData.geoCords[jobDetails?.job_uid] = jobDetails?.customer_address?.geo_cordinates || [];
    }
    else {
      delete this.routeJobConfirmationDialogData.geoCords[jobDetails?.job_uid];
    }
    this.updateSelectedJobCountInConfirmationDialog();

  }

  addJobsToRouteClickEvent = (event: any): void => {
    if (this.drawOnMapNavbarData.selectedPolylinePopupInstance) {
      this.drawOnMapNavbarData.selectedPolylinePopupInstance.closePopup();
      this.drawOnMapNavbarData.selectedPolylinePopupInstance.unbindPopup();
    }
    if(this.drawOnMapNavbarData.routeHomeMarkerInstance) {
      this.drawOnMapNavbarData.routeHomeMarkerInstance.target.closePopup();
      this.drawOnMapNavbarData.routeHomeMarkerInstance.target.unbindPopup();
    }
    let selectedJobs = this.drawOnMapNavbarData.selectedJobs.map((selectedJob: any) => selectedJob?.job);
    selectedJobs = this.formatJobDetails(selectedJobs);
    this.initRouteJobConfirmationDialogData(selectedJobs);
    this.routeJobConfirmationDialogData.selectedRoute = this.drawOnMapNavbarData.selectedRoute;
    this.routeJobConfirmationDialogData.dialogInstance = this.matDialog.open(this.routeAddJobConfirmationDialogContent, {
      panelClass: ['route-job-confirm-dialog'],
      disableClose: false,
      data: { selectedRoute: this.drawOnMapNavbarData.selectedRoute, selectedJobs: selectedJobs }
    });
    this.routeJobConfirmationDialogData.dialogInstance.afterClosed().subscribe((isClosed: boolean) => {
      if (isClosed) {
        this.routeJobConfirmationDialogData = { dialogInstance: null, jobs: {}, selectedJobCount: 0, geoCords: {}, selectedRoute: null};
        this.clearDrawOnMap();
      }
    });
  };

  closeAddJobConfirmationDialog(): void {
    if (this.routeJobConfirmationDialogData.dialogInstance) {
      this.routeJobConfirmationDialogData.dialogInstance.close();
    }
  }

  onRouteAddJobCompleted(): void {
    const selectedJobUids: any[] = Object.keys(this.routeJobConfirmationDialogData.geoCords);
    const targetRouteUid: string = this.routeJobConfirmationDialogData.selectedRoute?.route_uid;
    if (targetRouteUid) {
      if (selectedJobUids?.length) {
        const payload = { jobs: [] };
        selectedJobUids.forEach((jobUid: any) => {
          if (this.routeJobConfirmationDialogData.geoCords[jobUid]) {
            payload.jobs.push({ job_uid: jobUid, geo_cords: this.routeJobConfirmationDialogData.geoCords[jobUid] });
          }
        });
        const routeUpdateLoadingToast = this._toast.loading(this.utilityService.getLocaleValue('recurring_route.toast.route_jobs_updating'));
        this._dispatchBoardService.assignRouteJob(targetRouteUid, payload, (status: boolean) => {
          routeUpdateLoadingToast.close();
          if (status) {
            this.routeJobConfirmationDialogData.dialogInstance.close(true);
            this.drawCompleted.emit({
              type: 'update',
              routeUid: targetRouteUid,
              addedJobs: payload.jobs
            });
          }
        });
      }
    }
  }

  toggleNewRoute(): void {
    this.routeFormOption = {
      state: 'new',
      header: 'route.create'
    };;
    this.currentRoute = {};;
    this.currentRoute['jobs'] = this.allSelectedMarkers.map((marker: any) => ({ 'job': marker.options.job, 'geo_cords': marker?.getLatLng() }));;
    this.openNewRoute = true;
    if(this.isDispatch) {
      this.routeCreationTimezone = this._dispatchBoardService.selectedTimezone.ROUTES;
    }
  }

  onNewActionComplete(event: any): void {
    if (event?.completed) {
      this.allSelectedMarkers = [];
      this.drawnLayers?.clearLayers();
      this.routeCreated.emit(event);
    }
    this.openNewRoute = false;
    this.currentRoute = null;
  }

  async plotJobPolyLine(): Promise<void> {
    if (this.employeeLocation && this.jobLocation) {
      // Get the first employee and job coordinates
      const employeeCoordinates = this.employeeLocation[0]?.location_data;
      const jobCoordinates = this.jobLocation[0]?.customer_address?.geo_cordinates;
      if (employeeCoordinates && jobCoordinates) {
        const employeeLatLng = [employeeCoordinates.latitude, employeeCoordinates.longitude];
        const jobLatLng = [jobCoordinates[0], jobCoordinates[1]];
        const params = {
          'routingMode': 'fast',
          'transportMode': 'car',
          'origin':  employeeLatLng,
          'destination': jobLatLng,
          'spans' : 'duration,baseDuration,length',
          'return': 'polyline'
        };
        const router = this.platform.getRoutingService(null, 8);
        let sections: any[] = []
        await router.calculateRoute(params, (data: any) => {
          if (data?.routes[0]?.['sections']) {
            sections = data.routes[0]['sections'];
            const temp = data.routes[0]?.sections[0]?.spans[0]
            const distance = temp ? this.utilityService.getDistance(temp['length']) : '';
            const eta = temp ? Math.round(temp['duration'] / 60) : '';
            this.trackEvent.emit({
              eta: eta,
              distance: distance
            })
            const linestring = H.util.flexiblePolyline.decode(data.routes[0]?.sections[0].polyline);
            const routeColor: string = '#1abc9c';
            const enhancedRouteColor: string = this.utilityService.darkenHex(routeColor, 18);
            const antPolyline = L.polyline(linestring.polyline, {
              'color': routeColor,
              'weight': 5,
            });
            antPolyline.on('mouseover', (event: any) => this.onMouseOver(event, antPolyline, enhancedRouteColor));
            antPolyline.addTo(this.map);
          }
          else {
            sections = [];
          }
        });
      }
    }
  }


  //#region Filters
  initMapFilterDependency(): void {
    this.initiateFilterOptions();
    const _filterOptions = _.cloneDeep(this._MapService.MapFilterList);
    this.dateOptions = this._MapService.DateOptions;
    if (!this.filterValueMap) {
      this.filterValueMap = _.reduce(_filterOptions, (acc, filters, module) => {
      acc = acc || {};
      filters.forEach((filter: any) => {
        acc[`${module}_${filter.id}`] = { 
        ...filter, 
        module, 
        formattedDisplayValue: this.utilityService.getLocaleValue(filter.displayKey, filter.displayName) 
        };
      });
      return acc;
      }, {});
    }
    if (this.utilityService.companyConfig?.general?.distance_metric === 'MILES') {
      this.nearbyConfig.range.max = 9;
      this.nearbyConfig.range.min = 3;
      this.nearbyConfig.range.value = 3;
    }
    else {
      this.nearbyConfig.range.max = 12;
      this.nearbyConfig.range.min = 6;
      this.nearbyConfig.range.value = 6;
    }
    this.nearbyConfig.range.rangeList = Array.from({ length: this.nearbyConfig.range.max - this.nearbyConfig.range.min + 1 }, (_, i) => this.nearbyConfig.range.min + i);
    this.nearbyConfig.range.unit = this.utilityService.companyConfig?.general?.distance_metric === 'MILES' ? this.utilityService.getLocaleValue('maps.mi') : this.utilityService.getLocaleValue('maps.km');
    this.initializeFilterCount();
  }

  initiateFilterOptions(): void {
    const allModules = Object.keys(this._MapService.MapFilterList) as MapModule[];
    this.filterOptions = allModules.reduce((acc, currentModule) => {
      const selectedModuleFilters = this._MapService.MapFilterList[currentModule] || [];
      acc[currentModule] = selectedModuleFilters.map((filter: MapFilterOption) => {
      let selectedValue = this.defaultNearbyFilterValue[`${currentModule}_${filter.id}`] || filter.selectedValue;
      let isSelected = !!this.defaultNearbyFilterValue[`${currentModule}_${filter.id}`];
      let formattedDisplayValue = this.utilityService.getLocaleValue(filter.displayKey, filter.displayName);

      if (filter.type === 'DATE' && this.defaultNearbyFilterValue[`${currentModule}_${filter.id}`]) {
        const rangeKey = this.defaultNearbyFilterValue[`${currentModule}_${filter.id}`];
        selectedValue = this.getDateRangeByKey(rangeKey);
        isSelected = true;
        formattedDisplayValue = selectedValue?.map((value: any) => value.format(this.dateFormat)).join(' - ');
        filter = { ...filter, rangeKey };
      }

      return {
        ...filter,
        formattedDisplayValue,
        selectedValue,
        isSelected,
      };
      });
      return acc;
    }, {} as Record<MapModule, MapFilterOption[]>);
    this.updateFilterCount(null, true);
    this.deferredCallbackFlags.dependenciesInitialized = true;
    if (this.deferredCallbackFlags.initialNearByRequestPending) {
      this.applyAndEmitNearByFilter();
      this.deferredCallbackFlags.initialNearByRequestPending = false;
    }
  }
  
  cleanUpMapFilterDependency(): void {
    this.clearAllFilters();
    if (this.nearbyZone.circlePolylineRef) {
      this.map.removeLayer(this.nearbyZone.circlePolylineRef);
    }
    if (this.nearbyZone.newSourceMarkerRef) {
      if (this.nearbyZone.fromModule === 'JOB') {
        this.jobMarkersMap.delete(this.nearbyZone.newSourceMarkerRef?.options?.eventDetails?.job_uid);
      }
      this.map.removeLayer(this.nearbyZone.newSourceMarkerRef);
    }
    if (this.nearbyZone.polylineRef) {
      this.map.removeLayer(this.nearbyZone.polylineRef);
    }
    this.createPanToMaskBtn();
    this.nearbyZone = { circlePolylineRef: null, circleCenterGeoCords: null, oldSourceMarkerRef: null, newSourceMarkerRef: null, fromModule: null, toModule: null, eventDetails: null, circleBound: null, polylineRef: null, currentPolylineCacheId: null, teamUid: null, currentActiveMarker: null, currentDestinationMarker: null };
    if (this.utilityService.companyConfig?.general?.distance_metric === 'MILES') {
      this.nearbyConfig.range.max = 9;
      this.nearbyConfig.range.min = 3;
      this.nearbyConfig.range.value = 3;
    }
    else {
      this.nearbyConfig.range.max = 12;
      this.nearbyConfig.range.min = 6;
      this.nearbyConfig.range.value = 6;
    }
  }

  resetNearbySourceMarker(): void {
    if (this.nearbyZone.oldSourceMarkerRef) {
      if (this.nearbyZone.fromModule === 'JOB') {
        if (this._dispatchTemplateBoardService.metaData?.map?.layers?.jobs && this.nearbyZone.oldSourceMarkerRef?.options?.job?.source !== 'nearByJob') {
          this.jobLayerGroup.addLayer(this.nearbyZone.oldSourceMarkerRef);
          this.jobMarkersMap.set(this.nearbyZone.oldSourceMarkerRef?.options?.job?.job_uid, this.nearbyZone.oldSourceMarkerRef);
        }
      }
    }
  }

  clearNearbyData(): void {
    this._dispatchBoardService.cancelNearByDataRequest$.next();
    if (this.isDispatch) {
      this._dispatchBoardService.resetNearByMapData(this._dispatchBoardService.activeDispatchTab, this._dispatchTemplateBoardService.metaData);
    }
  }

  initializeFilterCount(): void {
    this.filterCountData.count = Object.keys(this._MapService.MapFilterList).reduce((acc, module) => {
      acc[module] = 0;
      return acc;
    }, {} as Record<MapModule, number>);
  }

  toggleNearBy(): void {
    this._MapService.isNearByEnabled.set(!this._MapService.isNearByEnabled());
  }

  debouncedUpdateNearbyRange = _.debounce((value: number) => {
    this.updateNearByRadius(value);
  }, 200, { leading: false, trailing: true });

  onNearByRangeChange(event: Event): void {
    const value = +(event.target as HTMLInputElement).value;
    this.debouncedUpdateNearbyRange(value);
  }

  updateNearByRadius(value: number): void {
    this.nearbyConfig.range.value = value;
    this.createNearbyMask();
    this.applyAndEmitNearByFilter();
  }

   updateFilterCount(module: MapModule = this.selectedFilterModule, allFilters: boolean = false): void {
    if (allFilters) {
      this.filterCountData.count = Object.keys(this.filterOptions).reduce((acc, module) => {
        acc[module] = this.filterOptions[module].filter((filter: MapFilterOption) => {
          if (!_.isEqual(this.filterValueMap?.[`${module}_${filter?.id}`]?.selectedValue, filter?.selectedValue)) {
            return true;
          }
          return false;
        })?.length || 0;
        return acc;
      }, {} as Record<MapModule, number>)
    }
    else {
      this.filterCountData.count[module] = this.filterOptions[module].filter((filter: MapFilterOption) => {
        if (!_.isEqual(this.filterValueMap?.[`${module}_${filter?.id}`]?.selectedValue, filter?.selectedValue)) {
          return true;
        }
        return false;
      })?.length || 0;
    }
    this.filterCountData.showClearAll = Object.keys(this.filterCountData.count).some((module: MapModule) => {
      if (module === this.selectedFilterModule) {
        return false;
      }
      return this.filterCountData.count[module] > 0;
    });
     this.checkFilterScrollButtons();
  }

  getDateRangeByKey(rangeKey: string): any[] {
    switch (rangeKey) {
      case 'TODAY':
        return [dayjs()];
      case 'TOMORROW':
        return [dayjs().add(1, 'days')];
      case 'NEXT_7_DAYS':
        return [dayjs().add(1, 'days'), dayjs().add(7, 'days')];
      case 'NEXT_30_DAYS':
        return [dayjs().add(1, 'days'), dayjs().add(30, 'days')];
      case 'YESTERDAY':
        return [dayjs().subtract(1, 'days')];
      case 'LAST_7_DAYS':
        return [dayjs().subtract(7, 'days'), dayjs().subtract(1, 'days')];
      case 'LAST_30_DAYS':
        return [dayjs().subtract(30, 'days'), dayjs().subtract(1, 'days')]; 
      default:
        return [];
    }
  }

  onFilterBtnClick(event: MouseEvent, filter: MapFilterOption): void {
    if (filter.type === 'BOOLEAN') {
      this.filterInstanceData.filter = filter;
      if (!filter.isSelected) {
        this.onFilterApply();
      }
    } else {
      if (filter?.type === 'DATE') {
        if (this.dateOptions?.length && this.dateOptions[0]?.rangeKey === 'TODAY') {
          if (!this.dateOptions[0]?.value?.[0] || !dayjs().isSame(this.dateOptions[0]?.value?.[0], 'day')) {
            this.dateOptions = this.dateOptions.map((dateOption: any) => {
              if (dateOption?.rangeKey) {
                dateOption.value = this.getDateRangeByKey(dateOption?.rangeKey);
              };
              return dateOption;
            });

            this.dateOptions = this._MapService.DateOptions.map((dateOption: any) => ({
              ...dateOption,
              dateValueString: dateOption.value.map((date: any) =>
                date.format(this.dateFormat)).join(` ${this.utilityService.getLocaleValue('text.to', 'to')} `)
            }));
          }
        }
      }
      else if (filter.type === 'LOOKUP') {
        filter.lookupOptions.preselectedValues = Array.isArray(filter.selectedValue) ? filter.selectedValue : [];
      }

      this.filterInstanceData.filter = _.cloneDeep(filter);

      if (this.filterInstanceData?.instanceRef) {
        this.filterInstanceData?.instanceRef?.hide();
      } else {
        if (event?.target) {
          const targetButton = (event?.target as HTMLElement).closest('button');
          if (targetButton) {
            const tooltipContent = this.getFilterMenuTemplateContent();
            this.filterInstanceData.instanceRef = tippy(targetButton, {
              ...this.filterTippyProps,
              content: tooltipContent,
              onHidden: () => {
                this.cleanFilterTippyContent();
              }
            });
            this.filterInstanceData.instanceRef.show();
            this.filterInstanceData.isOpened = true;
          }
        }
      }
    }
  }

  getFilterMenuTemplateContent(): HTMLElement {
    this.cleanFilterTippyContent();

    this.filterContentViewRef = this.filterMenuContentRef.createEmbeddedView({
      filter: this.filterInstanceData.filter
    });
    this.filterContentViewRef.detectChanges();

    const div = document.createElement('div');
    this.filterContentViewRef.rootNodes.forEach((node: any) => div.appendChild(node));
    return div;
  }

  trackFilterBy(index: number, filter: any): string {
    return filter?.id || index;
  }

  cleanFilterTippyContent(): void {
    if (this.filterContentViewRef) {
      this.filterContentViewRef.destroy();
      this.filterContentViewRef = null;
    }

    if (this.filterInstanceData?.instanceRef) {
      this.filterInstanceData.instanceRef.destroy();
      this.filterInstanceData.instanceRef = null;
    }

    this.filterInstanceData.isOpened = false;
    this.selectedOptionsBucket = {};
  }

  onSelectOptionChange(event: any): void {
    this.selectedOptionsBucket = event;
  }

  onFilterApply(): void {
    const selectedFilter: MapFilterOption = this.filterInstanceData.filter;
    if (selectedFilter?.type === 'DATE') {
      if (selectedFilter.rangeKey) {
        selectedFilter.selectedValue = this.getDateRangeByKey(selectedFilter.rangeKey);
        selectedFilter.isSelected = true;
        selectedFilter.formattedDisplayValue = selectedFilter?.selectedValue?.map((value: any) => value.format(this.dateFormat)).join(' - ');
      }
      else {
        selectedFilter.isSelected = false;
        selectedFilter.formattedDisplayValue = this.utilityService.getLocaleValue(selectedFilter.displayKey, selectedFilter.displayName);
      }
    }
    else if (selectedFilter?.type === 'BOOLEAN') {
      selectedFilter.isSelected = true;
      selectedFilter.selectedValue = true;
    }
    else if (selectedFilter?.type === 'LOOKUP') {
      selectedFilter.selectedValue = this.selectedOptionsBucket?.values;
      selectedFilter.formattedDisplayValue = this.selectedOptionsBucket?.displayNames?.length > 2 ? `${this.selectedOptionsBucket?.displayNames?.slice(0, 2).join(', ')} + ${this.selectedOptionsBucket?.displayNames?.length - 2} ${this.utilityService.getLocaleValue('text.more')} `
        : this.selectedOptionsBucket?.displayNames?.join(', ');
        if (Array.isArray(selectedFilter.selectedValue)) {
          if (selectedFilter.selectedValue?.length) {
            selectedFilter.isSelected = true;
          }
          else {
            selectedFilter.isSelected = false;
          }
        }
    }
    this.filterOptions = _.cloneDeep(this._MapService.updateFilterValue(this.filterOptions, this.selectedFilterModule, selectedFilter?.id, selectedFilter));
    if (this.filterInstanceData?.instanceRef) {
      this.filterInstanceData.instanceRef.hide();
    }
    this.filterInstanceData.isOpened = false;
    this.updateFilterCount();
    this.applyAndEmitNearByFilter();
  }

  onFilterClear(filter?: MapFilterOption): void {
    if (this.filterInstanceData?.instanceRef) {
      this.filterInstanceData.instanceRef.hide();
    }
    this.filterInstanceData.filter = filter ?? this.filterInstanceData.filter;
    const originalFilterValue = this.filterValueMap[`${this.selectedFilterModule}_${this.filterInstanceData.filter?.id}`];
    this.filterOptions = _.cloneDeep(this._MapService.updateFilterValue(this.filterOptions, this.selectedFilterModule, this.filterInstanceData.filter?.id, originalFilterValue));
    this.filterInstanceData.isOpened = false;
    this.selectedOptionsBucket = { values: [], displayNames: [] };
    this.updateFilterCount();
    this.applyAndEmitNearByFilter();
  }

  clearAllFilters(allFilters: boolean = false): void {
    if (!this.filterOptions) { return; }
    if (!allFilters) {
      this.filterOptions[this.selectedFilterModule] = this._MapService.MapFilterList[this.selectedFilterModule].map((filterOptions: MapFilterOption) => {
        let isSelected = !!this.defaultNearbyFilterValue[`${this.selectedFilterModule}_${filterOptions.id}`];
        if (filterOptions.type === 'DATE') {
          isSelected = filterOptions?.isSelected ?? false;
        }
        return {
          ...filterOptions,
          isSelected,
          formattedDisplayValue: this.utilityService.getLocaleValue(filterOptions.displayKey, filterOptions.displayName)
        };
      });
      this.selectedOptionsBucket = { values: [], displayNames: [] };
    }
    else {
      Object.keys(this.filterOptions).forEach((module: MapModule) => {
        this.filterOptions[module] = this._MapService.MapFilterList[module].map((filterOptions: MapFilterOption) => {
          let isSelected = !!this.defaultNearbyFilterValue[`${module}_${filterOptions.id}`];
          if (filterOptions.type === 'DATE') {
            isSelected = filterOptions?.isSelected ?? false;
          }
          return {
            ...filterOptions,
            isSelected,
            formattedDisplayValue: this.utilityService.getLocaleValue(filterOptions.displayKey, filterOptions.displayName)
          };
        });
      });
      this.selectedOptionsBucket = { values: [], displayNames: [] };
    }
    this.updateFilterCount();
    this.applyAndEmitNearByFilter();
  }
  
  filterScrollLeft() {
    const container = this.mapContainer?.nativeElement?.querySelector('#filter-scroll-container');
    if (container) {
      container.scrollBy({ left: -150, behavior: 'smooth' });
      requestAnimationFrame(() => this.checkFilterScrollButtons());
    }
  }

  filterScrollRight() {
    const container = this.mapContainer?.nativeElement?.querySelector('#filter-scroll-container');
    if (container) {
      container.scrollBy({ left: 150, behavior: 'smooth' });
      requestAnimationFrame(() => this.checkFilterScrollButtons());
    }
  }

  checkFilterScrollButtons(delay: number = 100): void {
    setTimeout(() => {
      const container = this.mapContainer?.nativeElement?.querySelector('#filter-scroll-container');
      if (container) {
        this.showLeftScrollButton = container.scrollLeft > 0;
        this.showRightScrollButton = container.scrollLeft + container.clientWidth < container.scrollWidth;
      } else {
        this.showLeftScrollButton = false;
        this.showRightScrollButton = false;
      }
    }, delay);
  }

  getNearByRadiusValue(): number {
    const rangeValue = this.nearbyConfig.range.value;
    if (this.utilityService.companyConfig?.general?.distance_metric === 'MILES') {
      return rangeValue * 1609.34; // Convert miles to meters
    } else {
      return rangeValue * 1000; // Convert kilometers to meters
    }
  }

  createAnimatedMarker(latLng: any): any {
    if (latLng) {
      const dropInIcon = L.divIcon({
        className: 'nearby-center-wrapper',
        html: `<div class="nearby-center-marker drop-in">
                 <img src="assets/images/svgs/map_main_marker.svg"/>
               </div>`,
        iconSize: [40, 40],
        iconAnchor: [20, 40],
      });
      const marker = L.marker(latLng, { icon: dropInIcon, zIndexOffset: 9999, eventDetails: this.nearbyZone.eventDetails });
      marker['target'] = marker;
      marker.on('click', (marker: any) => {
        if (!marker?.target?.getPopup()) {
          this.bindMarkerPopup(this.nearbyZone.fromModule.toLowerCase(), marker, this.nearbyZone.eventDetails, true);
        }
        const popup = marker?.target?.getPopup();
        popup.on('remove', () => {
          marker?.target?.unbindPopup();
        });
      });
      marker.addTo(this.map);
      this.nearbyZone.newSourceMarkerRef = marker;
      return marker;
    }
  }
  

  createNearbyMask(center: any[] = this.nearbyZone.circleCenterGeoCords, radius: any = this.getNearByRadiusValue()): void {
    //Create a center pin
    if (!this.nearbyZone.newSourceMarkerRef) {
      this.createAnimatedMarker(center);
    }
    //Create a circle around the center pin
    const outerBounds = [ [90, -180], [90, 180], [-90, 180], [-90, -180] ];
    const circlePoints = [];
    const steps = 1080;
    for (let i = 0; i <= steps; i++) {
      const angle = (i / steps) * 2 * Math.PI;
      const dx = radius * Math.cos(angle);
      const dy = radius * Math.sin(angle);
      const deltaLat = dy / 111320;
      const deltaLng = dx / (40075000 * Math.cos(center[0] * Math.PI / 180) / 360);
      circlePoints.push([center[0] + deltaLat, center[1] + deltaLng]);
    }
  
    const latlngs = [outerBounds, circlePoints];
  
    if (!this.nearbyZone.circlePolylineRef) {
      this.nearbyZone.circlePolylineRef = L.polygon(latlngs, {
        color: '#000',
        fillColor: '#000',
        fillOpacity: 0.35,
        stroke: false,
        interactive: true,
      }).addTo(this.map);
    } else {
      this.nearbyZone.circlePolylineRef.setLatLngs(latlngs);
    }

    this.nearbyZone.circleBound = L.latLngBounds(circlePoints);
    this.map.fitBounds(this.nearbyZone.circleBound, { padding: [50, 50] });
    this.createPanToMaskBtn();
  }

  createPanToMaskBtn(): void {
    if (this.map && this._MapService.isNearByEnabled()) {
      if (!this.panToMaskBtnRef) {
        const PanToMaskControl = L.Control.extend({
          options: {
            position: 'bottomright',
            interactive: false
          },
          onAdd: () => {
            const mapPanToMaskWrap = L.DomUtil.create('div', 'leaflet-bar leaflet-control custom-control-container border-none cursor-pointer bg-white shadow-md');
            const mapPanToMaskBtn = L.DomUtil.create('a', 'flex items-center justify-center text-center bg-transparent', mapPanToMaskWrap);
            mapPanToMaskBtn.title = this.utilityService.getLocaleValue('maps.pan_to_nearby', 'Pan to Nearby');
            mapPanToMaskBtn.innerHTML = `<i class='ti ti-map-pin text-3xl text-gray-700'></i>`;
            mapPanToMaskBtn.onclick = (): any => {
              if (this.nearbyZone.circleBound) { 
                this.map.fitBounds(this.nearbyZone.circleBound, { padding: [50, 50] });
              }
              else {
                this.map.panTo(this.nearbyZone.circleCenterGeoCords);
              }
            };
            L.DomEvent.disableClickPropagation(mapPanToMaskWrap);
            L.DomEvent.disableScrollPropagation(mapPanToMaskWrap);
            return mapPanToMaskWrap;
          }
        });
        this.panToMaskBtnRef = new PanToMaskControl();
        this.map.addControl(this.panToMaskBtnRef);
      }
    }
    else {
      if (this.panToMaskBtnRef) {
        this.map.removeControl(this.panToMaskBtnRef);
      }
      this.panToMaskBtnRef = null;
    }
  }

  changeFilterModule(module: MapModule): void {
    this.selectedFilterModule = module;
    this.updateFilterCount();
  }

  applyAndEmitNearByFilter(): void {
    const filterParms = _.reduce(this.filterOptions, (acc, filters, module) => {
      acc = acc || {};
      filters.forEach((filter: any) => {
        if (filter.isSelected) {
          if (filter.type === 'DATE' && _.isArray(filter?.filterKeyMap) && _.isArray(filter?.selectedValue)) {
            const selectedDateRange = filter?.selectedValue;
            if (selectedDateRange?.length === 1) {
              selectedDateRange.push(selectedDateRange[0]);
            }
            filter?.filterKeyMap.forEach((key: any, index: any) => {
              if (selectedDateRange[index]) {
                acc[key] = selectedDateRange[index].format('YYYY-MM-DD');
              }
            });
          }
          else if (_.isArray(filter.selectedValue)) {
            acc[`${filter.filterKeyMap}`] = filter.selectedValue.join(',');
          }
          else if (_.isString(filter.selectedValue)) {
            acc[`${filter.filterKeyMap}`] = filter.selectedValue;
          }
          else {
            acc[`${filter.filterKeyMap}`] = filter.selectedValue;
          }
        }
      });
      return acc
    }, {})
    filterParms['radius'] = this.getNearByRadiusValue();
    if (Array.isArray(this.nearbyZone.circleCenterGeoCords) && this.utilityService.isValidGeoCords(this.nearbyZone.circleCenterGeoCords)) {
      filterParms['location'] = this.nearbyZone.circleCenterGeoCords.join(',');
    }
    if (this.nearbyZone.fromModule === 'JOB' && this.nearbyZone.eventDetails?.job_uid) {
      filterParms['near_by_tech_from_job'] = this.nearbyZone.eventDetails?.job_uid;
    }
    if (this._MapService.isNearByEnabled()) {
      this._MapService.nearByParams.set(filterParms);
    }
  }

  //Lifecycle Hooks
  ngOnInit(): void {
    this.platform = new H.service.Platform({
      apikey: env.hereMapKey
    });
    this.mapSettings = this._localStorageService.getLocalStorage('map_settings');
  }

  ngAfterViewInit(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((res) => {
        if (res?.coords?.latitude && res?.coords?.longitude) {
          this.activeGeoCords = [res.coords.latitude, res.coords.longitude];
          this.currentLocation = [...this.activeGeoCords]
          this.initMap(true);
        }
      }, (err) => {
        this.initMap(false);
      });
    }
    this.checkFilterScrollButtons();
  }

  ngOnDestroy(): void {
    if (this.employeeLocationData?.unsubscribe) {
      this.employeeLocationData.unsubscribe();
    }
    if (this.drawerPreviewUid?.unsubscribe) {
      this.drawerPreviewUid.unsubscribe();
    }
    if (this.sidebarState?.unsubscribe) {
      this.sidebarState.unsubscribe();
    }
    if (this.assetLocationData?.unsubscribe) {
      this.assetLocationData.unsubscribe();
    }
    if (this.jobLocationData?.unsubscribe) {
      this.jobLocationData.unsubscribe();
    }
    if (this.organizationLocationData?.unsubscribe) {
      this.organizationLocationData.unsubscribe();
    }
    if (this.propertyLocationData?.unsubscribe) {
      this.propertyLocationData.unsubscribe();
    }
    if (this.customerLocationData?.unsubscribe) {
      this.customerLocationData.unsubscribe();
    }
    if (this.routeLocationData?.unsubscribe) {
      this.routeLocationData.unsubscribe();
    }
    if (this.serviceTerritoryLocationData?.unsubscribe) {
      this.serviceTerritoryLocationData.unsubscribe();
    }
    if (this.markerState?.unsubscribe) {
      this.markerState.unsubscribe();
    }
    if (this.territoryDrawer?.unsubscribe) {
      this.territoryDrawer.unsubscribe();
    }
    if (this.jobDrawer?.unsubscribe) {
      this.jobDrawer.unsubscribe();
    }
    if (this.map) {
      this.map.eachLayer((layer: any) => {
        this.map.removeLayer(layer);
      });
      this.map?.off();
      this.map?.remove();
    }
    this.unSubscribe$.next();
    this.unSubscribe$.complete();

    this.toolButtons.forEach((button: any) => {
      if (button.element) {
        button.element.removeEventListener('click', () => this.toggleDrawTool(button.tool));
      }
    });
    this.stopMapEventListener();
    this.updateLegendDetails(null, null, false, true);
    this._MapService.isLegendBarOpen = false;
    this._MapService.openTooltip.jobUid = null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.mapView?.currentValue !== changes?.map_view?.previousValue) {
      if (changes?.mapView?.currentValue?.latitude) {
        this.setMapView(changes.mapView.currentValue);
      }
      else if (changes?.mapView?.currentValue?.location_data?.latitude) {
        const data = {
          'latitude': changes.mapView.currentValue.location_data.latitude,
          'longitude': changes.mapView.currentValue.location_data.longitude
        };
        this.setMapView(data);
      }
      else if (changes?.mapView?.currentValue?.asset_location?.geo_cordinates) {
        const data = {
          'latitude': changes.mapView.currentValue.asset_location.geo_cordinates[0],
          'longitude': changes.mapView.currentValue.asset_location.geo_cordinates[1]
        };
        this.setMapView(data);
      }
      else if (changes?.mapView?.currentValue?.property_address?.geo_cordinates) {
        const data = {
          'latitude': changes.mapView.currentValue.property_address.geo_cordinates[0],
          'longitude': changes.mapView.currentValue.property_address.geo_cordinates[1]
        };
        this.setMapView(data);
      }
      else if (changes?.mapView?.currentValue?.customer_address?.geo_cordinates) {
        const data = {
          'latitude': changes.mapView.currentValue.customer_address.geo_cordinates[0],
          'longitude': changes.mapView.currentValue.customer_address.geo_cordinates[1]
        };
        this.setMapView(data);
      }
      else if (changes?.mapView?.currentValue?.organization_address?.geo_cordinates) {
        const data = {
          'latitude': changes.mapView.currentValue.organization_address.geo_cordinates[0],
          'longitude': changes.mapView.currentValue.organization_address.geo_cordinates[1]
        };
        this.setMapView(data);
      }
      else if (changes?.mapView?.currentValue?.start_location?.geo_cords?.length) {
        const data = {
          'latitude': changes?.mapView?.currentValue?.start_location?.geo_cords[0],
          'longitude': changes?.mapView?.currentValue?.start_location?.geo_cords[1]
        };
        this.setMapView(data);
      }
    }
  }

}
